import jEn from './j-en.js';

export default {
  router: {
    index: {
      home: 'home',
      pageSearch1: 'User Query Management',
      pageSearch2: 'User Query',
      pageSearch2_1: "Log off user information",
      pageRoom1: 'Room Management',
      pageRoom2: 'Room Query',
      pageRoom3: 'Room tag management',
      pageRoom4: 'Room background management',
      pageRoom5: 'Room backgroundedit',
      pageRoom6: 'Activities & Background checks',
      pageRoom7: 'Homeowner certification',
      pageRoom8: 'Room flow details',
      pageRoom9: 'Room monitoring list',
      pageRoom10: 'Room reception',
      pageRoom11: 'Room turntable',
      pageRoom12: 'Room reception details',
      pageRoom13: 'Room running on the hour',
      pageAd: 'Ads & pop-ups',
      login: 'Log In',
      error401: 'error 401',
      error404: 'error 404',
      error500: 'error 500',
      pageGift1: 'Gifts & Expressions',
      pageProps1: 'Props Mall',
      pageProps2: 'Item Mangement',
      pageProps3: 'Sales statistics',
      pageProps4: 'Coupons',
      pageProps5: 'user list',
      pageProps6: 'Nameplate Mangement',
      pageProps7: 'Ring Mangement',
      pageAdmin1: 'administrator',
      pageAdmin2: 'Super administrator',
      pageAdmin3: 'Country administrator',
      refundCenter: "Refund Processing Center",
      pageAccount1: 'Administrator account settings',
      pageAccount2: 'System Account Settings',
      pageManagement1: 'Role Permission management',
      pageManagement2: 'Role Permission Settings',
      operationLog1: 'Operation log',
      roomColumn: 'Banner management',
      violatingUser: 'Violating user management',
      systemMessage: 'System message',
      scriptManagement:'Script Management',
      housePatrolScript:'House Patrol Script',
      partyRoomScript:'Party Room Script',

      pageFamily: 'Family information query',
      pageFamily2: 'Family Dissolution Application',
      pagetion1: "Operational Activities Configuration",

      pageSensitive: 'Sensitive word management',
      pageCountry1: 'State management',
      pageHost1: 'Host Management',
      pageAgent1: 'Agent management',
      pageAgent2: 'ta recharged person',
      pageAgent3: 'Proxy top-up list',
      pageAgent4: 'Monthly sales statistics',
      pageAgent5: 'Monthly sales statistics',
      pageCrystal: 'Room crystal',
      pageHost2: 'Historical deduction of diamond records',
      pageHost3: 'Room contribution list',
      lostOrder: 'Failed order query',
      appleLostOrder: 'Apple Failed order query',
      kaManagement:'KA management',

      notList: 'Unissued list',
      supportBlacklist: 'Support blacklist',
      risk: 'Block blacklist',

      'ActivityManagement': 'Activity management',
      'activityPage1': 'week Star',
      'activityPage2': 'The stars poet',
      'activityPage3': 'sweepstakes',
      'activityPage4': 'Hit a golden eggs',
      'activityPage5': 'Top-up activities',
      'activityPage6': 'Reward configuration',
      'activityPage7': 'Cp certification',
      'activityPage9': 'Revenue activities',
      'groupActivity': 'Group activity',


      'invitationMessage': 'Invite Management',
      'developerMessage': 'Developer management',
      'equipmentManagement': 'Equipment management',
      'ipQuery': 'IP Information Query',
      'familyLeague': 'The league of the family',
      'annualDrums': 'The annual war drums',
      'honorWall': 'Honor wall',
      'annualFestival': 'The annual festival',
      'millionsPk': 'Millionaire Pk',
      'ludoPage': 'Ludo blacklist',
      'matchQuery': 'Match the query',
      'userRegistration': 'New User registration',
      'setting': 'Set up the',
      'feedbackList': 'Feedback list',
      'managementList': 'Manage the ID list',
      'specialMoment': 'Special moment',
      'specialMomentV3': 'Special moment V3',
      'riskcontrolManagement': 'Recharge risk control management',
      'riskManagement': 'Risk control management',
      'familyStar': 'The star of the family',
      jackpotActivities: 'Jackpot activities',
      theVoice: 'The voice',
      newUserReview: 'New user award review',
      bdManagement: 'BD Management',
      guildManagement: 'Guild Management',
      guildStatistics: 'Guild Statistics',

      pageData:'Data Statistics',
      pagePlatform1: 'Platform operation data',
      pageTreasureHunt1:'Adventure treasure hunt',
      foodie:'Foodie Statistics'

    },
    router: {
      beforeClose: {
        sureClose: 'Sure to close this page',
      },
    },
  },
  views: {
    public: {
      copyUrl: 'Copy Url',

      more: 'To view',
      operatSuccess: 'Operation Succeed',
      operatError: 'Operation Failed',
      pass: 'Pass',
      refuse: 'Refuse',
      passed: 'Passed',
      refused: 'Refused',
      close: 'Close',
      submit: 'Submit',
      yes: 'Yes',
      no: 'No',
      sure: 'confirm',
      cancel: 'cancel',
      prompt: 'Prompt',
      operation: 'Operation',
      delete: 'Delete',
      edit: 'Edit',
      query: 'Search',
      update: 'Modify',
      turkish: 'Turkish',
      arabic: 'Arabic',
      indonesian: 'Indonesian',
      en: 'English',
      all: 'All',
      noPermission: 'No permission',
      pleaseChoose: 'please choose',

      none: 'Empty',
      sex: 'Porn / Sex',
      curse: 'Insult',
      religion: 'Disrespect for Religion',
      terroristActivities: 'Terrorist Activities',
      violationOfLaw: 'Violation of Law',
      propaganda: 'Promote Other App',
      resetHeadImg: 'Reset Avatar',
      confirmOpear: 'Confirm the operation',
      noneData: 'No data',
      operatSuccessUpdate: 'Operation successful, updating status',
      male: 'male',
      confidential: 'Confidential',
      female: 'Female',
      ban24h: 'Ban 24 hours',
      ban72h: 'Ban 72 hours',
      ban30D: 'Ban 30 days',
      permanentBan: 'Permanent ban',
      save: 'Save',
      chooseImg: 'Select Image',
      clear: 'Clear',
      chooseAll: 'Select all',
      search: 'Search',
      pleaseChooseTarget: 'Please select the target',
      showBigImg: 'View Larger Image',
      startTime: 'Starting time',
      endTime: 'End Time',
      enterRoomId: 'Please enter the room ID',
      exportText: 'Export',
      minute5: '5 minutes',
      hour1: '1 hour',
      hour2: '2 hours',
      hour4: '4 hours',
      hour6: '6 hours',
      hour12: '12 hours',
      hour24: '24 hours',

      add: 'Add to',

      areaText1: 'English language',
      areaText2: 'Arabic',
      areaText3: 'Indonesian',
      areaText4: 'Turkish',
      areaText5: 'Hindi',
      areaText6: 'Vietnamese',
      areaText7: 'Thai',

      saveEdit: "Save and create associative pairings",
      saveEdit2: "Save and create association",

      selectMore: "Check multiple choice",
      time: "Time",

      imageUploadLimit:'Upload picture exceeds the limit size',
    },
    userDestroy:{
      originalID:'Original ID',
      destroyID:'Assign ID',
      addTime:'Submit logout time',
      handleTime:'Logout expiration time',
      status:'Logout status',
      status1:'Logging off',
      status2:'Logged out',
      status3:'Canceled',

      totalRecharge:'Total recharge',
      banCount:'Number of closures',
    },
    riskcontrolManagement: {
      tab1: 'The risk of account',
      tab2: 'Intercept the log',
      tab1text1: 'Interception channel',
      tab1text2: 'Interception times',
      tab1text3: 'Last intercept time',
      tab1text4: 'level',
      tab1text5: 'Balance of gold COINS',
      tab1text6: 'Total Recharge (USD)',
      tab1text7: 'Registered IP(Number of accounts)',
      tab1text8: 'Machine code',
      tab1text9: 'Add the time',
      tab1text10: 'To add people',
      tab1text11: 'Add risk Account',
      tab1text12: 'Add IP to risk control',
      tab1text13: 'Add machine code to risk control',
      tab1text14: 'Feature code (you can fill in the payment account such as PayPal account. If you do not fill in the payment account, only the account will be blocked)',

      tab1text15: 'Batch delete',
      tab1text16: 'Modifying a Risk Account',
    },
    refundCenter: {
      refundOrderNo: "Refund order number",
      cumulativeRepayment: "Cumulative repayment",
      lastWarningTime: "Last warning time",
      refundDetails: "Refund details",
      repaymentRecord: "Repayment record",
      frozenAccountDetails: "Frozen account details",
      refundWarning: "Refund warning",
      refundWarningSure: "确认发送退款警告？",
      freezeAccount: "Freeze account",
      binChargeType: "Disable recharge",
      repaymentProcessing: "Repayment processing",
      refundedCoins: "refunded coins",
      refundTime: "refund time",
      totalSameIp:"Total",
      selectUser:'Please select a user first',
      selectRechargeType:'Please select the type of recharge disabled',

      deviTotal_tip:"Cumulative refund for all accounts under the device: %%%%, cumulative recharge: ####",
      sureBanRechargeType:"Are you sure you want to disable the recharge method?",


    },
    developerMessage: {
      page1Text1: 'Logical ID',
      page1Text2: 'The user ID',
      page1Text3: 'Device ID',
      page2Text1: 'IP',
      page2Text2: 'Add the time',
      page2Text3: 'Logical id',


      page5Text1: 'Registered IP address Statistics',
      page5Text2: 'Registered Device Statistics',
      page5Text3: 'Log in statistics',
      page5Text4: 'Log in abnormal',
      page5Text5: 'The current number of',
      page5Text6: 'Statistical time',
      page5Text7: 'Registration number',
      page5Text8: 'The logged in user',
      page5Text9: 'Login type',
      page5Text10: 'The login time',
      page5Text11: 'Trigger a number of',

      page6Text1: 'Total amount of gold allowed for gift this month',
      page6Text2: 'The number of non-gift distributions allowed this month',
      page6Text3: 'Creation time',
      page6Text4: 'Modify the time',
      page6Text5: '',

    },
    kaManagement: {
      rechargeTotal:'Total recharge',
      add:'newly added',

      addResult:'Add results',
      tipsText1:'In English, separate',
      tipsText2:'Users added successfully',
      tipsText3:'The following user already exists',
      tipsText4:'The following users failed to add',

    },

    communityLanguage: {
      language1: 'English',
      language2: 'Arabic',
      language3: 'Indonesian',
      language4: 'Turkish',
      language5: 'Hindi',
      language6: 'Vietnamese',
      language7: 'Thai',
      language8: 'Brazil',
      language9: 'Spanish',
      language10: 'Gulf group',
      language11: 'Indonesian',
      language12: 'Portugal',
      language1Area: 'English area',
      language2Area: 'Arabic',
      language3Area: 'Indonesian area',
      language4Area: 'Turkish speaking area',
      language5Area: 'Hindi area',
      language6Area: 'Vietnamese area',
      language7Area: 'Thai area',
      language8Area: 'Brazil',
      language9Area: 'Spanish area',
      language10Area: 'Indonesian area',
      language11Area: 'Portuguese area',
      language12Area: 'Bay area',
    },
    userInformation: {
      enterId: 'Please enter user ID',
      userId: 'User ID',
      invalidId: 'This ID is invalid.',
      noUser: 'The user was not found',
      //
      search: 'Search',
      banCount: 'Banned',
      times: '{counts} Times',
      showDetail: 'see details',
      giveCoin: 'Give away gold coins',
      setSpread: 'Set as promoter',
      cancelSpread: 'Cancel promoter',
      setAgent: 'Set as agent',
      cancelAgent: 'Cancel agent',
      setNationAdmin: 'Set as country administrator',
      cancelNationAdmin: 'Cancel country administrator',
      setSuperAdmin: 'Set as Supervisor',
      cancelSuperAdmin: 'Cancel Supervisor',
      userNo: 'ID',
      headerImg: 'Avatar',
      nickname: 'Nickname',
      gender: 'Gender',
      wealthLevel: 'Wealth class',
      charmLevel: 'Charm level',
      activeLevel: 'Active level',
      checkDetail: 'View details',
      btnTxt: 'User Label Management',
      text1: 'Interest in',
      text2: 'movement',
      text3: 'The game',
      remainingCoins: "remaining coins",

    },
    page401: {
      content: 'You do not have permission to browse this page.',
    },
    page404: {
      content: 'Oh ~~ Your Page Seems To Fly Away ~',
    },
    page500: {
      content: 'Oh ~~ Ghost Knows What The Server Has Experienced ~',
    },
    backBtnGroup: {
      backHome: 'Back To Home Page',
      backLast: 'Go Back To The Last Page',
    },
    login: {
      title: 'Salam management system',
    },
    roomManagement: {
      enterRoomId: 'Please enter the room ID',
      roomId: 'Room ID',
      enterIdInvalid: 'This ID is invalid.',
      notFoundRoom: 'The Room was not found',
      roomName: 'Room name',
      roomHeaderImg: 'Room avatar',
      roomOwnerId: 'Homeowner ID',
      roomOwnerName: 'Host Nickname',
      roomLevel: 'Room class',
      onlineNum: 'online users',
      roomLabel: 'Room label management',
      bgManage: 'Background management',
      auditManage: 'Audit management',
      roomOwner: 'Homeowner certification',
      showInfo: 'View information',
      roomLabelText: 'Room tag',
      lastMonthAward: 'Last month reward',
      monthAward: 'Reward of the month',
      lastMonthAward: 'Last month reward',
      thisMonthAward: 'Reward of the month',
      banRoom: 'Lift the room',
      unBanRoom: 'Lift the ban on all servers',
      banText: 'Ban',
      foreverBan: 'Permanent ban',
      unTop: 'Click to cancel to top',
      top: 'Top',
      to: 'to',
      minute5: '5 minutes',
      hour1: '1 hour',
      hour2: '2 hours',
      hour12: '12 hours',
      setTop: 'Set Sticky',
      selectTime: 'Select date',
      topStartTime: 'Sticky start time',
      topTime: 'Sticking time',
      hour2: '2 hours',
      hour4: '4 hours',
      hour6: '6 hours',
      hour24: '24 hours',
      timeOrTypeNotNull: 'Stick start time or stick duration cannot be empty',
      management: 'Room management',
      flowQuery: 'Room flow query',
      assessment: 'Room management assessment',
      supportRoom: 'Support room management',
      roomBinding: 'Room binding',
      checkCancelTop: 'Confirm the unpinning operation?',
      roomReception: 'Room reception',
      roomTurntable: 'Room turntable',

      text1: 'Room Support Person',
      text2: 'Number of Subscribers',
      text3: 'The name of the column',
      text4: 'Activity Support has been added',
      text5: 'Add Activity support ',
      text6: 'Confirm the issuance of activity support',
      text7: 'Changing the Online time',
      text8: 'Activity of the water',
      text9: 'Confirm to add',
      text10: 'membership',
      text11: 'Star rating',
      text12: 'The room of the water',
    },
    roomDetail: {
      title: 'Title',
      content: 'Content',
      roomId: 'Room ID',
      ban: 'Ban',
      roomName: 'Room Name',
      roomImg: 'Room Avatar:',
      bg: 'Room theme:',
      expirationDate: 'Expiration Date',
      tags: 'Label',
      level: 'Room Level',
      updateNickname: 'Modify Room Nickname',
      updateNumber: 'Modify the room number',
      nicknameUnNone: 'Please enter the nickname',
      //
      sureBanRoom: 'Confirm to ban the room',
      sureUnbanRoom: 'Confirm to unblock the room',
      liftTheBan: 'Lift the ban',
      chooseTime: 'Choose ban time',
      permanentBan: 'Permanent Ban',
      roomBlacklist: 'Room blacklist',
      userId: 'User ID',
      userNickname: 'User Nickname',
      deleteUser: 'Remove',
      checkDeleteUser: 'Are you sure you want to remove the user {username} from the blacklist?',
      checkUpdateLevel: 'Confirm revision level?',
      levelNoChange: 'Level not modified',
      checkUpdateNumber: 'Confirm to modify the room number?',
      sevenDays: '30 days',
      checkSave: 'OK to save?',

      //
      createdTime: "Time of creation",
      roomSupportDetails: "Room support details",
      topTime: "Time to top ",
      country: "Country",
      coins: "Gold coins",
      releaseTime: "Release time",
      supportType: "Type of support",
      userLv: 'User level (wealth/Glamour/Activity)',
      registrationTime: "Registration time",
      supportStar: "Star support",
      supportRoom: "Support room",



    },
    // 邀请信息管理
    invitationMessage: {
      text1: 'Viewing Invitation Details',
      text2: 'Invite level',
      text3: 'The invitation message',
      text4: 'Bind invitations',
      text5: 'The invitation reason',
      text6: 'The binding time',
      text7: 'head',
      text8: 'Last landing time',
      text9: 'User level (wealth/Glamour/Activity)',
      text10: 'The name of the inviter',
      text11: 'Name of the person invited',
      text12: 'The invitation list',
      text13: 'Invite the number',
      text14: 'Invitees of today',
      text15: 'Invite people in the last 7 days',
      text16: 'Invite people in the last 30 days',
      text17: 'Add promoters',
      text18: 'Historical invitation',
      text19: 'Bulk binding',
      text20: 'Confirm the binding',

      //
      promoter: "Promoter",
      promoter_no: "Promoter ID",

      invitee: "Invitee",
      invitee_no: "Invitee ID",




    },
    user_data: {
      third_order_id: 'third order id',

      title: 'Title',
      content: 'Content',
      number: 'ID',
      addItem: 'Add Items',
      add: 'Add',
      setItem: 'Item Settings',
      endItem: 'End of Item',
      headImg: 'Avatar',
      chooseImg: 'Select Image',
      clear: 'Clear',
      nickname: 'Username',
      gender: 'Gender',
      male: 'Male',
      confidential: 'Confidential',
      female: 'Female',
      birthday: 'Date of Birth',
      phone: 'Cell Phone',
      email: 'Mailbox',
      country: 'Country',
      province:'Province',
      hobby: 'Hobby',
      tag: 'Label',
      sign: 'Signature',
      familyName: 'Guild Name',
      rechargeAmount: 'Recharge Amount (Yuan)',
      agentRecharge: 'Agency Recharge (Usd)',
      contribution: 'Contribution Value',
      charmValue: 'Charm Value (Gold Coins)',
      goldCoin: 'Gold Coin Balance',
      diamond: 'Diamond Balance',
      exchange: 'Total Number of Diamonds Exchanged for Diamonds',
      registerTime: 'Registration Time',
      allequipment: "Same device account",
      registerIp: 'Register IP',
      moreIp: 'More IP',
      lastLoginTime: 'Last Login Time',
      monthEarnings: "This Month's Rewards",
      lastMonthEarnings: "Last Month's Rewards",
      createRoomId: 'Room ID',
      memorandum: "Memorandum",
      addMemo: "Add memo",
      enterMemoContent: "Please enter the content of the memo ...",
      consumptionAmount: "This consumption amount",
      remainingQuota: "Remaining quota",
      unlimited:"Unlimited",


      banId: 'Ban ID',
      banBroadcast: "Ban Broadcast",
      UnbanBroadcast: "Unban broadcast",
      clickToBan: "Click to ban",
      banTimeTo: 'The Ban is Up To:',
      permanentBan: 'Permanent Ban',
      ban: 'Ban',
      liftTheBan: 'Unbanned',
      banEquipment: 'Ban Equipment',
      banCount: 'Banned',
      times: '{counts} times',
      freezeConsumption: 'Freeze Consumption',
      freezeing: 'Freezing',
      normal: 'Normal',
      inMai: 'on-mic Time',
      wealthClass: 'Wealth lLevel',
      charmLevel: 'Charm Level',
      activeLevel: 'Active Level',
      banReason: 'Reasons for Ban',
      itemType: 'Item Type',
      items: 'Items',
      aging: 'Validity(Days)',
      numOrDate: 'Quantity or effective duration (days)',
      updateNum: 'Modify ID',
      numberId: 'User ID',
      updateNickname: 'Change Username',
      nickname: 'Username',
      detailList: 'List of Details',
      vehicle: 'Mount',
      medal: 'Medal',
      headdress: 'Headwear',
      number: 'User ID',
      VIP: 'Aristocracy',
      hasAccount: 'There are {num} accounts',
      authentication: 'Authentication',
      day: 'day',
      // 补
      gift: 'Gift',
      coupon: 'Coupon',
      roomMedal: 'Room Medal',
      sureUpdateImg: 'Sure to change the avatar?',
      sureDeleteItem: 'Sure to delete this item?',
      enterIdInvalid: 'This ID is invalid.',
      enterNoNone: 'Please enter the nickname',
      enterReason_1: "Please enter the reason",
      selectReason: "Please select a reason for ban",
      selectBanDays: 'Please select the number of days to ban',
      sureBanId: 'Sure to ban this ID?',
      sureUnBanId: 'Sure to unban this ID?',
      sureBanDevice: 'Sure to ban this device?',
      sureUnBanDevice: 'Sure to unban this device?',
      sureBanBroadcast: "Are you sure you want to block the broadcast?",
      sureUnBanBroadcast: "Are you sure you want to lift the ban broadcast?",
      banDuration: "Ban duration",

      //
      setTtem: 'Set props',

      sureUpdatePs: 'Confirm password change?',
      psNotNull: 'password can not be blank',
      freezeMoney: 'Freeze consumption',
      unFreezeMoney: 'Unfreeze',
      sureFreeze: 'Are you sure to freeze consumption?',
      sureUnFreeze: 'Sure to unfreeze',
      sureUpdateCounty: 'Are you sure you want to modify the country?',
      updatePhoneBind: 'Change phone',
      updateMail: 'Change mailbox binding',
      updatePhone: 'Edit phone number',
      phoneNum: 'telephone number',
      updateMail: 'Modify mailbox',
      labelMail: 'mailbox',
      blockText: 'Black out',
      sureBlock: 'Are you sure to black out?',
      pleaseEnterInfo: 'Please enter missing order information',
      missOrder: 'Missing order information',
      rechargeAmountText: 'Recharge amount',
      rechargeTime: 'Recharge time',

      chargeType: 'Recharge type',
      wechat: 'WeChat',
      alipay: 'Alipay',
      applyPay: 'Apple Pay',
      googlePay: 'Google Pay',
      palpay: 'paypal',

      agentRechargeText: 'Agent recharge',
      agentInternal: 'Agent internal recharge',
      commerceCharge: 'E-commerce recharge',
      payssion: 'payssion',
      payoneer: "payoneer",
      deductCoins:'Deduct coins',

      otherPay: 'Other payments',
      tapPay: 'tap payment',
      huaweiPay: 'Huawei Pay',
      payerPay: 'Eggplant Express Payment',
      dlocalRecharge: "dlocal recharge",
      paypalRecharge: "paypal recharge",
      checkoutRecharge: "checkout recharge",



      userNo: 'User ID',
      agentUserNo: 'Agent ID',
      agentHeaderImg: 'Agent avatar',
      agentNickname: 'Agent Nickname',
      showItem: 'View props',
      itemDetail: 'Prop details',
      showDetail: 'See details',
      otherId: 'The other side',
      typeText: 'Types of',
      teamTime: 'Composition relationship time',
      point: 'integral',
      showCp: 'cp relationship',
      cpDetail: 'Special cp relationship',
      enterReason: 'Please fill in the reason for banning',
      table2Text3: 'Reason for ban',
      text1: 'Deducted from the gold COINS',

      labelTxt1: 'Tag name',
      labelTxt2: 'Label category',
      labelTxt3: 'The sorting',
      labelTxt4: 'area',

      labelTxt5: 'Number of coins earned',

      labelTxt6: 'Conversion of diamonds',
      labelTxt7: 'Registration type',
      labelTxt8: 'Unbound item',
      labelTxt9: 'unbundling',
      labelTxt10: 'Modifying Identity Authentication',

      labelTxt11: 'User original ID',
      labelTxt12: 'The user id',
      labelTxt13: 'User state',
      labelTxt14: 'Certification of the room',
      labelTxt15: 'The authentication type',
      labelTxt16: 'certified',
      labelTxt17: 'unauthorized',

      labelTxt_reason: 'Certification Reason ',
      labelTxt18: 'Certification Reason (zh)',
      labelTxt19: 'Certification Reason (en)',
      labelTxt20: 'Certification Reason (ar)',
      labelTxt21: 'Certification Reason (tr)',
      labelTxt22: 'Certification Reason (in)',

      labelTxt23: 'Authentication level',
      labelTxt24: 'statement',
      labelTxt25: 'Spending time',
      labelTxt26: 'Consumption type',
      labelTxt27: 'The amount of',
      labelTxt28: 'Certification of reason',
      diamonDe: 'The diamond subsidiary',
      labelTxt29: 'Reasons for certification (pt)',
      labelTxt30: 'Reasons for certification (hi)',
      labelTxt31: 'Reasons for certification (es)',
      labelTxt32: 'Reasons for certification (th)',
      labelTxt33: 'Reasons for certification (vi)',
      labelTxt34: 'Change the binding number',
      labelTxt35: 'Certification Start time',
      labelTxt36: 'Authentication End time',
      labelTxt37: 'Reset the data',
      labelTxt38: 'Replace the picture',
      labelTxt38_1: 'Replace the picture',
      labelTxt39: 'Banned IP',
      labelTxt40: 'Unban IP',

      freeze:'frozen',
      unfreeze:'unfreeze',
      freezePoint:'Freeze points',
      currentPoint:'Current points',
      freezeModalTitle:'Please enter the number of freezing points',
      subTitle:'That is, the amount of gold coins obtained by malicious refund',
      points:'point',
      svipFreezeTitleText:'Recent operation record',
      freezeTime:'Frozen time',
      unfreezeMsg:'Whether to unfreeze the user\'s svip',

      notPointText:'Please enter the number of freezing points',

      notSpecialText:'Please select a special gift type',
      notSVIPText:'Please select SVIP level',


      changeGender:'Modify gender',
      chooseGender:"Choose gender",

      userNameplate:'Personal nameplate',
      addNameplate:'Add nameplate',

    },
    ip_detail: {
      enterUserId: 'Please enter user ID',
      // 补
      userId: 'userId',
      loginTime: 'Registration Time',
      loginUser: 'Registered user',
      loginIp: 'Register ip',
      lastLoginTime: 'last login time',

      nickname: 'Nickname',
      deviceCode: 'Device Code',
      country: 'Country',
      wealth: 'Wealth',
      charm: 'Charm',
      activeLevel: 'Active Level',
      banAll: 'Ban All',
      banChooseUser: 'Ban Selected Users',
      chooseAll: 'Select all',
      sureBanUser: 'Confirm to ban these users.',

      unBanDevice: "Unban the device",

    },
    moreUserUpList: {
      chooseAll: 'Select All',
      banAll: 'Ban All',
      banChooseUser: 'Ban Selected Users',
      choose: 'Select',
      sureBanAll: 'Ban them all ?',
      enterBanUser: 'Please select a users.',
      sureBanUser: 'Confirm to ban these users.',
      banTimeTo: 'Ban Time',
      permanentBan: 'Permanent ban',
      enterUserId: 'Please enter user ID',
      search: 'Search',
    },
    giving: {
      giveCoin: 'Give away gold coins',
      coinNum: 'Number of gold coins',
      actualAmount: 'The actual amount',
      type: 'Types of',
      coinType: 'Currency',
      giftReason: 'Gift reason',
      recharge: 'System recharge',
      familyEntry: 'Family entry',
      support: 'Family support',
      award: 'Activity Award',
      distribution: 'Internal distribution',
      otherRewards: 'Other rewards',
      agentRecharge: 'Agent recharge',
      roomSupport: 'Room support',
      extRewards: 'External management rewards',
      USD: 'USD',
      Yuan: 'Yuan',

      notNoticeText:'',
    },
    roomLabel: {
      labelName: 'Label name',
      color: 'Colour',
      label: 'Label',
      editLabel: 'Edit label',
      delLabel: 'Remove label',
      addLabel: 'Add tag',
      modalWarn: 'Fill in the label name or color cannot be empty',
      comfirmDel: 'Confirm delete label?',
    },
    roomBg: {
      sort: 'Sort',
      bgImg: 'Background picture',
      price: 'price',
      sell: 'Sales volume',
      isOn: 'Put on the shelf',
      isOff: 'Off shelf',
      addBg: 'Add room background',
      bgSmallImg: 'Background image',
      bgBigImg: 'Background big picture',
      dayTime: 'Effective time (days)',
      pleaseDay: 'Please enter a valid time',
      prize: 'price',
      pleasePrize: 'Please enter the price',
      saleNum: 'Sales volume',
      pleaseSaleNum: 'Please enter sales',
      sort: 'Sort value',
      pleaseSort: 'Please enter the sort value (the larger the value, the higher the ranking)',
      enterNum: 'Please fill in the numbers',
      pleaseEnterImg: 'Please upload small background image and large background image',
      checkDelRoomBg: 'Confirm to delete the room background',
      checkOnOperat: 'Confirm execution of listing operation',
      checkDownOperat: 'Confirm execution of delisting operation',
    },
    auditManage: {
      activeAudit: 'Activity review',
      bgAudit: 'Background review',
      disband: 'Room dissolution application',
      passSelectBg: 'By selected background',
      roomId: 'room number',
      bg: 'background',
      areaSearch: 'Area screening',

      roomIdText: 'Room id',
      activer: 'Event initiator',
      activeTitle: 'Event title',
      activeContent: 'Activities',
      activeStart: 'Activity start time',
      activeEnd: 'Event end time',
      activeCreate: 'Event creation time',
      activePoster: 'Poster base map',
      roomLiangId: 'Room number',
      status: 'Status',
      auditing: 'under review',
      auditPass: 'examination passed',
      refused: 'be rejected',
      checkPass: 'Confirm execution of pass operation',
      checkRefuse: 'Confirm rejection',
      checkDelete: 'Confirm delete operation',
      batchPass: 'Batch pass',
      batchRefuse: 'Bulk rejection',
      checkBatchPass: 'Confirm the batch pass operation',
      checkBatchRefuse: 'Confirm batch rejection',
      applyDate: 'Date of Application',
      topText: 'Top',
      topWarn: 'Confirm to perform the pin operation',
      unTop: 'Unpink',
      unTopWarn: 'Confirm the unpinning operation',

      text1: 'Yes/no column',
      text2: 'The name of the column',
      text3: 'Activity initiator',
      text4: 'The room ID',
      text5: 'Activity title',
      text9: 'Active content',
      text6: 'Activity Start Time',
      text7: 'Activity end Time',
      text8: 'Activities for reproduction',
    },

    // 活动扶持
    activitiesSupport: {
      pageName: 'Activity support system',
      text1: 'Pre-activity support',
      text2: 'Post-activity support',
      text3: 'Have to support',
      text4: 'Has refused to',
      text5: 'The room id',
      text6: 'The owner id',
      text7: 'Activity title',
      text8: 'Active content',
      text9: 'The room temperature',
      text10: 'Support the number of',
      text11: 'Support times of the week',
      text12: 'Cumulative times of support',
      text13: 'Play water',
      text14: 'This water',
      text15: 'This field supports the gold coin number',
      text16: 'Reward gift',
      text17: 'Activity Start Time',
      text18: 'Activity end Time',
      text19: 'Activity creation time',
      text20: 'The name of the column',
      text21: 'state',
      text22: 'countries',
      text23: 'Agreed to support',
      text24: 'Refuse to support',
      text25: 'Modify support plan',
      text26: 'Whether to provide support',
      text27: 'Whether to deny support',
      text28: 'Modify support plan',
      text29: 'Modify support plan',

      text30: 'Record the screen',
      text31: 'Check the record screen',
      text32: 'The Times of support have exceeded 2 times this week, so it is suggested that no support reward be given',
      text33: 'Room certification',
      text34: 'Accreditation room application review',
      text35: 'Certification of the room',
      text36: 'Certification support release records',
      text37: 'Batch Support',
      text38: 'Batch denial of support',
      text39: 'Support blacklist',
      text40: 'The star room',

    },
    auditManageBg: {
      roomLiangId: 'Room number',
      status: 'Status',
      allAudit: "All",
      unAudit: 'Unreviewed',
      audited: 'Audited',
      roomNum: 'room number',
      roomBg: 'background',
      auditPass: 'examination passed',
      refused: 'be rejected',
      checkPass: 'Confirm execution of pass operation',
      checkRefuse: 'Confirm rejection',
      writeReason: 'Fill in the reason',
      checkBatchPass: 'Confirm the batch pass operation',
      checkBatchRefuse: 'Confirm batch rejection',
      batchPass: 'Batch pass',
      batchRefuse: 'Bulk rejection',
    },
    auditManageDisband: {
      roomId: 'Room ID',
      roomName: 'Room name',
      roomImg: 'Room avatar',
      owerId: 'Host ID',
      nickname: 'Homeowner nickname',
      level: 'Room level',
      hot: 'Room heat',
      currentMonth: 'This month the water',
      application: 'Application time',
      roomLiangId: 'Room number',
      ignore: 'ignore',
      dismiss: 'Dismiss the room',
      checkIgnore: 'Confirm to ignore the room dissolution application',
      checkDismiss: 'Confirm to dissolve the room',
      ignored: 'Ignored',
      dismissed: 'Disbanded',
    },
    roomOwner: {
      goldMedal: 'gold medal',
      silverMedal: 'silver medal',
      type: 'Types',
      roomLiangId: 'Room number',
      level: 'Room certification level',
      sort: 'Sort',
      userLiang: 'User ID',
      certification: 'Authentication type',
      symbol: 'Symbol type',
      equal: 'Equal sign',
      rises: 'rises',
      falls: 'falls',
      addCertification: 'Add certification',
      roomCert: 'Homeowner certification',
      comfirmIpt: 'Please fill in the complete information',
      checkDelete: 'Confirm delete operation',
    },
    roomRunning: {
      enterRoomId: 'Please enter the room ID',
      startTime: 'Starting time',
      endTime: 'End Time',
      export: 'Export',
      editRoom: 'Monitoring room list',
      allCountry: 'All countries/regions',
      pleaseEnter: 'Please enter country/region',
      country: 'country',
      roomHot: 'Room heat (0-0.1K)',
      roomHot2: 'Room heat (0.1-0.5K)',
      roomHot3: 'Room heat (0.5-1K)',
      roomHot4: 'Room heat (1-2K)',
      roomHot5: 'Room popularity (2-5K)',
      roomHot6: 'Room heat (above 5K)',

      time: 'time',
      roomOwner: 'Host ID',
      createTime: 'Creation time',
      roomLevel: 'Room level',
      nowHot: 'Current heat',
      totalCoin: 'Total turnover (gold coins)',
      todayCoin: 'Flow of the day (gold coins)',
      showDetail: 'View details',
      sendCoin: 'Issue gold coins',
      hourlyFlow: 'Hourly Flow',

      hourlyFlowT1: 'period',
      hourlyFlowT2: 'Current flow',
    },
    roomRunningDetail: {
      export: 'Export',
      sendCoin: 'Issue gold coins',
      enterCoin: 'Enter coins',
      roomId: 'Room ID',
      roomName: 'Room name',
      roomOwnerId: 'Host ID',
      roomNickname: 'Homeowner nickname',
      createTime: 'Room creation time',
      level: 'Room level',
      country: 'country',
      peakNumber: 'Monitor peak number of people',
      nowHot: 'Current heat',
      totalCoin: 'Total turnover (gold coins)',
    },
    roomSupport: {
      enterRoomId: 'Please enter the room ID',
      num: 'Serial number',
      roomId: 'Room ID',
      roomOwnerId: 'Host ID',
      roomFollow: 'Room cumulative flow',
      lastWeek: 'Last week',
      hot: 'heat',
      supportAdmin: 'Support administrator',
      supportText: 'Support standard',
      supportLevel: 'Support level',
      peopleNum: 'Current number/number limit',
      totalNum: 'Cumulative support times',
      createTime: 'add time',
      sendTime: 'Last release time',
      roomOwner: 'Homeowner',
      roomAdmin: 'Administrator',
      roomInfo: 'Room information',
      roomAvatar: 'Room avatar',
      ownerId: 'Host ID',
      totalSupport: 'Cumulative support',
      roomHot: 'Room heat',
      roomTotal: 'Total room flow',
      award: 'Reward standard',
      adminId: 'Administrator ID',
      adminAtLeast10: 'Up to 10 administrators',
      adminAtLeast1: 'At least 1 administrator',
      sendText: 'Issue',
      checkSend: 'Are you sure to distribute?',
      checkDel: 'confirm to delete?',
      addRoom: 'Add a room',
      exportExcle: 'Export Excle',
      enterRoomId2: 'Enter room id',
      chooseSend: 'Opt-out',
      checkSendTarget: 'Confirm to be issued to selected objects',
      checkSendCoin: 'The room is not more than 6 days since the last release, confirm the release',
      text1: 'List of support solutions',
      text2: 'region',
      text3: 'Plan identifies',
      text4: 'level',
      text5: 'Package name',
      text6: 'reward',
      text7: 'type',
      text8: 'Modify support plan',
      text9: 'New support plan',
      text10: '1 star',
      text11: '2 star',
      text12: '3 star',
      text13: 'The honorees ID',
      text14: 'Unissued list',
      text15: 'Room numbers should be issued',
      text16: 'Should send time',
      text17: 'Should send the user beautiful number',
      text18: 'Cause of failed provisioning',

      //
      giftWorth: "Gift worth",



    },
    roomManagementCheck: {
      roomId: 'Room ID',
      roomName: 'Room name',
      adminId: 'Administrator ID',
      adminName: 'Administrator nickname',
      enterTime: 'Entry time',
      leaveTime: 'departure time',
      servingTime: 'Serving time (minutes)',
      unLeave: 'Did not leave',
    },
    roomBind: {
      addBind: 'Add binding',
      roomId: 'Room id',
      inviteUser: 'Invite user id',
      weekCost: 'Flow this week',
      lastWeekCost: 'Last week',
      roomCreateTime: 'Room creation time',
      roomBindTime: 'Room binding time',
      roomUserNotNull: 'Room number or user number cannot be empty',
    },
    roomListening: {
      addRoom: 'Add 1 room',
      editTime: 'Edit monitoring start time',
      addTime: 'Add monitoring room',
      roomId: 'Room number',
      roomName: 'Room name',
      level: 'Level',
      roomOwnerId: 'Host ID',
      roomNickname: 'Homeowner nickname',
      startTime: 'Monitoring start time',
      checkDel: 'confirm deletion?',
      pleaseEnter: 'Please fill in the room number',
    },
    RoomReception: {
      tableText1: 'Region',
      tableText2: 'Room ID',
      tableText3: 'Homeowner ID',
      tableText4: 'Start Date',
      tableText5: 'End Date',
      tableText6: 'Number of receptionists',
      tableText7: 'Set people',
      tableText8: 'Set time',
      tableText9: 'Start',
      formText1: 'Room ID',
      formText2: 'Start time',
      formText3: 'End time',
      formText4: 'Region',
      tableText10: 'Room',
      tableText11: 'Date',
      tableText12: 'Number of receptionists',
      tableText13: 'second stay',
      formText5: 'New',
      btnText1: 'Details',
      btnText2: 'Start',
      btnText3: 'Time out',
      addRoomWarn: 'Not completed',
      checkDel: 'Confirm to delete this room reception?',
      addRoomTitle: 'New room reception',
      editRoomTitle: 'Edit room reception',
    },
    roomTurntable: {
      tableText1: 'Prize ID',
      tableText2: 'Prize name',
      tableText3: 'Prize Type',
      tableText4: 'Value',
      tableText5: 'Expiration time (card roll gift)',
      tableText6: 'Valid duration',
      tableText7: 'Current Quantity',
      tableText8: 'Daily average critical quantity',
      tableText9: 'prize probability',
      tableText10: 'Status',
      tableText11: 'Whether the screen is public',
      addAward: 'New prizes',
      typeText1: 'Card roll',
      typeText2: 'Gifts',
      typeText3: 'Gold coins',
      typeText4: 'Props',
      typeText5: 'Car',
      typeText6: 'Headwear',
      isOnText1: 'It has been added to',
      isOnText2: 'Not listed',
      select1Type1: 'Car',
      select1Type2: 'Card roll',
      select1Type3: 'Headwear',
      select1Type4: 'gift',
      select1Type5: 'gold',

      formText1: 'Prize type',
      formText2: 'Unit price (/gold coin)',
      formText3: 'Prize content',
      formText4: 'Effective time (days)',
      formText5: 'Storage validity period (days)',
      formText6: 'Current quantity',
      formText7: 'Daily critical quantity',
      formText8: 'Probability of Prize',
      formText9: 'Show icon',
      formText10: 'Is it on the shelf',
      formText11: 'Whether to push',
      formText12: 'Whether to scroll up',

      addTurnWarn: 'Display icon is not required',
      addAwarnTitle: 'New prizes',
      editAwardTitle: 'Edit prizes',
      upStatus1: 'Put on the shelf',
      upStatus2: 'Off shelf',
      upWarnText1: 'Confirm to perform the listing operation',
      upWarnText2: 'Confirm execution of delisting operation',
      deleteWarn: 'Confirm delete operation',
      tabText1: 'Prize pool setting',
      tabText2: 'Statistics',

      statisticsText1: 'Winning statistics',
      statisticsText2: 'Lottery statistics',
      statisticsText3: 'status',
      statisticsText4: 'filter',
      statisticsText5: 'date',
      statisticsText6: 'Prize pool ID',
      statisticsText7: 'date',
      statisticsText8: 'Prize name',
      statisticsText9: 'Number of wins',
      statisticsText10: 'Winning value',

      statisticsText11: 'Date',
      statisticsText12: 'Total number of draws',
      statisticsText13: 'Total number of draws',
      statisticsText14: 'Number of gold coins',
      statisticsText15: 'Total gold consumed',
    },
    pageAd: {
      addAd: 'Add ad',
      uped: 'It has been added to',
      waitUp: 'Pending',
      downed: 'Has been removed',
      down: 'Off shelf',
      up: 'Put on the shelf',
      adKeyword: 'Ad name keywords',
      adStatus: 'Ad status',
      unUp: 'Not listed',
      hasDown: "has been removed",
      adId: 'Advertising ID',
      upTime: 'Added time',
      adTitle: 'Ad headline',
      upArea: 'Shelf area',
      imgThum: 'Picture thumbnail (English)',
      // imgSmall: 'Picture View (English)',
      imgSmall: 'Picture View ',

      sort: 'Sort',
      status: 'status',
      minute5: '5 minutes',
      hour1: '1 hour',
      hour2: '2 hours',
      hour12: '12 hours',
      checkDel: 'confirm delete?',
      checkDown: 'Whether to remove the ad',
      checkUp: 'Whether to list the ad',
    },
    adDetail: {
      adInfo: 'Popular Banner',
      activityTitle: 'Event title',
      jumpRoom: 'Jump room',
      shareContent: 'Share content',
      thum: 'Thumbnail',
      adImg: 'ad pictures',
      sort: 'Sort',
      upArea: 'Shelf area',
      upTime: 'Added time',
      downTime: 'Time off',
      aArea: 'Arabic area',
      tArea: 'Turkish speaking region',
      yArea: 'Indonesian region',
      oArea: 'English',
      area5: 'Vietnamese',
      area6: 'Thai',
      area7: 'Indy',
      area8: 'Spanish',
      saveCreate: 'Save and create associated ads',
      saveCreate1: "Save and create association",

    },
    operationalPopup: {
      popup: 'login Message',
      tableText1: 'Popup title',
      tableText2: 'Pop-up content',
      tableText3: 'image',
      tableText4: 'area',
      tableText5: 'Object',
      tableText6: 'time',
      object0: 'All',
      object1: 'more than the',
      object2: 'Less than',
      object3: 'equal',
      object4: 'Wealth level greater than',
      object5: 'Wealth level is less than',
      object6: 'Wealth level equal to',
      object7: 'Charisma level is greater than',
      object8: 'Charm level is less than',
      object9: 'Charisma level is equal to',
      object10: 'Active level is greater than',
      object11: 'Active level is less than',
      object12: 'Active level equal to',

      formText1: 'Pop-up picture',
      formText2: 'Type (jump)',
      formText3: 'Topic ID/Post ID',
      formText4: 'URL',
      formText5: 'Room ID',
      formText6: 'Delivery language area',
      formText7: 'Issuing country',
      formText8: 'Object level',
      formText9: 'Is it only visible to new users',
      formText10: 'Daily listing time',
      formText11: 'Daily off time',
      formText12: 'Added time',
      formText13: 'Time off',
      formText14: 'Target',
      chooseImg: 'Select Image',
      clear: 'Clear',

      addPopup: 'Add operation popup',
      updatePopup: 'Modify operation popup',

      typeSelect1: 'Don\'t jump',
      typeSelect2: 'Recharge',
      typeSelect3: 'room',
      typeSelect4: 'H5',
      typeSelect5: 'Post',
      typeSelect6: 'topic',
      allOrNull: 'Select all/unselect all',
      selectOther: 'Reverse election',
      deletePopup: 'Confirm to delete the operation popup?',
      text1: 'Opening the Windows',
      text2: 'The tail ID',
      text3: 'Opening remarks',
      text4: 'Shelf region',
      text5: 'Preview picture',
      text6: 'Jump the URL',
      text7: 'The sorting',
      text8: 'operation',
      text9: 'Advertising note',
      text10: 'Popup window pictures',
      text11: 'Jump type',
      text12: 'Topic ID/ Post ID',
      text13: 'URL',
      text14: 'The room ID',
      text15: 'The user ID',
      text16: 'Display areas',
      text17: '',
      text18: '',
    },
    operationLog1: {
      1: 'User information query',
      2: 'Room management',
      3: 'Family information query',
      4: 'Advertising information query',
      5: 'Gift information query',
      6: 'Administrator account settings',
      7: 'Role authority management',
      8: 'Gold coin issuance management',
      9: 'Operation log',
      10: 'Super Administrator',
      11: 'System Message Management',
      12: 'Password Management',
      13: 'Event Management',
      14: 'Item Mall',
      15: 'State Management',
      16: 'Settings',
      17: 'User report',
      18: 'Host management',
      19: 'Agent management',
      20: 'Thematic room recommendation',
      21: 'sensitive word management',
      22: 'Room Crystal',
      23: 'Developer Management',
      24: 'Room monitoring',
      25: 'Room Support',
    },
    operationLog2: {
      1: 'User information query',
      2: 'Room management',
      3: 'Family information query',
      4: 'Advertising information query',
      5: 'Gift information query',
      6: 'Administrator account settings',
      7: 'Role authority management',
      8: 'Gold coin issuance management',
      9: 'Operation log',
      10: 'Super Administrator',
      11: 'System Message Management',
      12: 'Password Management',
      13: 'Event Management',
      14: 'Item Mall',
      15: 'State Management',
      16: 'Settings',
      17: 'User report',
      18: 'Host management',
      19: 'Agent management',
      20: 'Thematic room recommendation',
      21: 'sensitive word management',
      22: 'Room Crystal',
      23: 'Developer Management',
      24: 'Room monitoring',
      25: 'Room Support',
    },
    operationLog3: {
      1: 'Gift gold coins',
      2: 'Set as super administrator',
      3: 'Cancel super administrator',
      4: 'Set up agent',
      5: 'Cancel agent',
      6: 'Set country administrator',
      7: 'Cancel country administrator',
      8: 'Modify the name',
      9: 'New item',
      10: 'Delete item',
      11: 'Modify props',
      12: 'Modify avatar',
      13: 'Modify nickname',
      14: 'Modify country',
      15: '5 deduct gold coins',
      16: 'Modify password',
      17: 'Modify the bound mobile phone number',
      18: 'Modify the bound mailbox',
      19: 'Unbind',
      20: 'Block id',
      21: 'Unban id',
      22: '2 Banned devices',
      23: 'Unban device',
      24: 'Freeze consumption',
      25: 'Unfreeze consumption',
      26: 'Wealth Level',
      27: 'Charm Level',
      28: 'Activity level',
      29: 'Modify identity authentication 3',
      30: 'Set as a promoter',
      31: 'Cancel the promoter',
      32: 'Background review passed',
      33: 'Background review rejected',
      34: 'Activity approved',
      35: 'Activity review rejected',
      36: 'Delete event',
      37: 'Block room',
      38: 'Unlock the room',
      39: 'Modify the basic information of the room',
      40: 'Remove room blacklist',
      41: 'Top room',
      42: 'Cancel the top room',
      43: 'Add/modify room tag',
      44: 'Delete label',
      45: 'Add/modify room background',
      46: 'Delete room background',
      47: 'On/off',
      48: 'Room authentication',
      49: 'Delete room certification',
      50: 'Add room binding',
      51: 'review room dissolution application',
      52: 'Modify',
      53: 'Delete',
      54: 'Add',
      55: 'Reset data',
      56: 'Block user IP',
      57: 'Save gift information',
      58: 'Save emoji',
      59: 'Cancel item sale',
      60: 'Save item information',
      61: 'Delete coupons',
      62: 'Delete area gift',
    },
    operationLog: {
      1: 'User information query',
      2: 'Room management',
      3: 'Family information query',
      4: 'Advertising information query',
      5: 'Gift information query',
      6: 'Administrator account settings',
      7: 'Role authority management',
      8: 'Gold coin issuance management',
      9: 'Operation log',
      10: 'Super Administrator',
      11: 'System Message Management',
      12: 'Password Management',
      13: 'Event Management',
      14: 'Item Mall',
      15: 'State Management',
      16: 'Settings',
      17: 'User report',
      18: 'Host management',
      19: 'Agent management',
      20: 'Thematic room recommendation',
      21: 'sensitive word management',
      22: 'Room Crystal',
      23: 'Developer Management',
    },
    operationLogPage: {
      userId: 'User ID',
      roomId: 'Room number',
      startTime: 'Start Time',
      endTime: 'End Time',
      model: 'Module',
      table1: 'Created time',
      table2: 'Type',
      table3: 'Operation details',
      table7: 'Admin id',
      table4: 'Operation Reason',
      table5: 'Remarks information',
      table6: 'Operator',
      table8: 'Operating time',
      table9: 'Excluding time',
    },
    // 礼物信息查询
    giftInformation: {
      pageGift1: 'Gift Info',
      giftInformation: 'Gift information',
      shelves: 'Put on the shelf',
      offShelf: 'Off shelf',
      bringShelf: 'Bring shelf',
      beenOn: 'Has been on',
      beenOff: 'Has been off the shelves',
      giftId: 'Gift id',
      giftName: 'Gift name',
      giftBigIcon: 'Gift large icon',
      keyword: 'Please enter the gift name keyword search',
      giftSmallIcon: 'Gift small icon',
      bigThumb: 'Big thumb',

      gold: 'Gold',
      diamond: 'diamond',
      state: 'state',
      rackOrder: 'The rack order',
      operation: 'operation',
      time1: '5 minutes',
      time2: '1 hour',
      time3: '2 hour',
      time4: '12 hour',
      onShelves: 'Whether to put the product on shelves',
      offShelves: 'Whether to remove the product from the shelves',
      query: 'Query',
      newGift: 'New gift',
      editor: 'editor',
      chooseImg: 'Select Image',
      clear: 'Clear',
      special: 'Presents the special effects',
      chooseFile: 'Select the file',
      giftEffectsFile: 'Gift effects file',
      isEventGift: 'Is it an event gift?',
      anyMusic: 'Is there any music',
      enterText: 'Whether you can enter text',
      outputDiamond: 'Output of diamond',
      toastTxt: 'Note: the default diamond output value is shown here. It is 30% of the input gold value and the default output value. If the output ratio is unchanged, please do not change this value.',
      isShelf: 'Yes/no get off the shelf',

      shelfRegion: 'Shelf region',
      shelfTime: 'Shelf time',
      frameTime: 'Under the frame of time',
      toastText: 'Note: In English, separate',

      arabicArea: 'Arabic area',
      TRArea: 'Turkish-speaking region',
      inArea: 'Indonesian speaking region',
      other: 'Others (English)',


      expressionInformation: "Expression information",
      expressionManagement: 'Expression management',
      emojiEffects: 'Emoji effects',
      emojiEffectsFile: 'Emoji effects file',
      selectRegion: "Region",
      shelfOrder: "Shelf order",
      copyToOtherRegion: "Copy to other area",
      selectTargetRegion: "Select target region",

      eKeyword: 'Please enter emoji name keyword search',
      eId: 'Expression ID',
      eName: 'Expression Name',
      eImag: 'Expression figure',
      all: 'All',
      newExpression: 'New expression',
      remark: 'Remarks',
      btnBox1: 'Ordinary gift',
      btnBox2: 'Special gift',
      btnBox3: 'Country gift',
      btnBox4: 'Named gift',
      btnBox5: 'Romantic gift',
      btnBox6: 'SVIP gift',
      selectOpt1: 'ordinary',
      selectOpt2: 'special',
      selectOpt3: 'country',
      selectOpt4: 'Naming',
      selectOpt5: 'romantic',
      languageArr: 'Language area',
      upArea: 'Listed area',
      giftAdd: 'Gift addition',
      areaText: 'area',
      selectText: 'Columns',
      sortText: 'Sort',
      setArea: 'Set up partition',
      updateArea: 'Modify partition',
      giftUpdate: 'Gift modification',
      enterNum: 'Please enter the number',
      enterAreaNoNull: 'Region cannot be empty',
      enterNoNull: 'The content cannot be empty',
      languageArr: 'Language Area',
      userListBtn: 'user list',
      selectReOpt1: 'Turkish speaking region',
      selectReOpt2: 'Other (non-Turkish speaking regions)',
      remarkSelect: 'Remarks (optional)',
      isSpecial: 'Is it a special relationship gift',
      cpText: 'cp',
      friendText: 'forever&close',
      bindUserId: 'Bind user ID',
      deleteAreaGift: 'Delete area gift',
      checkDelAreaGift: 'Confirm delete area gift?',
      prizeTxt: 'A price range',

      text1: 'Partition name (Gift library name)',
      text2: "custom gift user id",
      text3: "Partition name (props library name)",

      price_rang_5000: "5000 and above",
      price_rang_all: "All",


    },
    itemsMall: {
      enterGift: 'Please enter the gift name',
      keyword: "keywords",
      addItem: 'Add props',
      downing: 'Under shelf',
      uping: 'Now on shelf',
      canSell: 'Can be sold',
      canNotSell: 'Not for sale',
      down: 'Off shelf',
      up: 'Put on the shelf',
      cancelSell: 'Cancel sale',
      setSell: 'Set for sale',
      userList: 'User list',
      itemName: 'Item name',
      classificat: 'classification',
      upDown: 'On/off',
      inOutSale: 'On/off',
      car: 'Car',
      middle: 'medal',
      headwear: 'Headwear',
      liangId: 'Liang',
      upDownText: 'On shelf & off shelf',
      inOutSaleText: 'On sale & discontinued',
      inSale: 'On sale',
      outOfSale: 'Discontinued',
      itemIcon: 'Prop display icon',
      effectTime: 'Effective time (days)',
      isUp: 'Is it on the shelf',
      isSale: 'Whether to sell',
      createTime: 'Creation time',
      checkDelItem: 'Make sure to delete the item?',
      checkDownItem: 'Whether to remove the product?',
      checkUpItem: 'Whether to list the product?',
      checkSetSale: 'Whether to set up for sale',
      checkCancelSale: 'Whether to cancel the sale',
      languageArr: 'Language area',
      userListBtn: 'user list',
      userRole: 'User list',
      userId: 'User ID',
      userNickname: 'User\'s Nickname',
      getTime: 'Get time',
      effectTime: 'Aging time',
      addUser: 'Add user',
      effectDay: 'Time limit (days)',
      enterNum: 'Please fill in the numbers',
      enterUserIdNotNull: 'The input user id cannot be empty and numeric',
      enterDayNotNull: 'The number of days entered cannot be empty and numeric',
      checkDeleteUser: 'Confirm to delete the user?',
      use_number: 'Number of users',
      text1: 'Vip card volume',
      text2: 'not  VIP card',
      text3: 'Number of items (duration)',
      text4: 'Prop the unit price',
      text5: 'Prop the total price',
      text6: 'Individual floating screen',
      text7: 'not  VIP card',
      text8: 'not  VIP card',
      text9: 'Special relationship card',
      text10: 'Chat bubble',
    },
    itemDetail: {
      giftInfo: 'Gift information',
      itemName: 'Item name',
      itemType: 'Item type',
      itemIcon: 'Prop display icon',
      iconSmall: 'Small icon',
      showIcon: 'Mall display icon',
      grayIcon: 'Grayscale icon',
      price: 'price',
      itemEffect: 'Special effects',
      chooseFile: 'Select the file',
      effectTime: 'Effective time (days)',
      checkUp: 'Is it on the shelf',
      checkSale: 'Whether to sell',
      checkLimitSale: 'Is it restricted',
      autoGet: 'Automatic acquisition',
      country: 'country',
      middleName: 'Medal name',
      middleType: 'Medal type',
      none: 'no',
      middle1: 'pk medal',
      middle2: 'Room King Medal',
      middle3: 'Medal of Love',
      middle4: 'Post-Love Medal',
      middle5: 'Zhou Couple Medal',
      middle6: 'Zhou Xing Medal',
      middle7: 'National Medal of Honor',
      middle8: 'National Special Medal',
      middle9: 'National Star',
      middle10: 'National Star Diamond',
      middle13: 'Rank medal',
      middle24: 'Medal of Achievement',
      middle25: 'Medal of Honor',

      middle11: 'Rank 27 MEDALS',
      middle12: 'StarsForAll medal',
      middle14: 'LoveForAll medal',
      middle15: 'Personal fans',
      middle16: 'Room attention',
      middle17: 'Room set-top',
      middle18: 'Top-up medal ',
      middle19: 'New recharge medal',
      middle20: 'Fruit Machine Medal',
      middle22: 'The medal of honor',
      middle23: 'The medal of honor',


      middle26: 'Medal of gift-giving',
      middle27: 'Accept a gift of',
      middle28: 'Medal of the Room Turntable',
      middle29: 'Lucky Box medal',
      middle30: 'StarsForAll gift',
      middle31: 'LoveForAll gift',
      middle32: 'The first medal of filling',
      middle33: 'Promotion officer medal',

      middle34: "Send the Moon for All medal",
      middle35: "Received the Moon for All Medal",
      middle36: "Teenpatti",
      middle37: "Promotion recharge medal",
      middle38: "Gourmet Game Medal",
      middle39: "Jackpot Medal",
      middle40: "Candy Medal",
      car: 'Car',
      middle: 'medal',
      headware: 'Headwear',
      liangId: 'Liang',
      roomMedia: 'Room Medal',
      eArea: 'English',
      aArea: 'Arabic',
      yArea: 'Indonesian',
      tArea: 'Turkish',
      allArea: 'Whole area',
      region: 'area',
      addItem: 'Add props',
      updateItem: 'Modify props',

      languageText1: 'Turkish',
      languageText2: 'Non-Turkish',
      languageText3: 'Vietnam',
      languageText4: 'Thailand',
      languageText5: 'Hindi',
    },
    saleList: {
      itemType: 'Item type',
      car: 'Car',
      media: 'medal',
      headware: 'Headwear',
      liangId: 'Liang',
      upDown: 'On shelf & off shelf',
      down: 'Off shelf',
      up: 'Put on the shelf',
      inOutSale: 'On sale & discontinued',
      inSale: 'On sale',
      outSale: 'Discontinued',
      itemName: 'Item name',
      price: 'unit price',
      saleNum: 'Sales volume',
      saleMoney: 'Sales',
    },
    itemCoupon: {
      addCoupon: 'Add coupons',
      couponName: 'Card name',
      price: 'unit price',
      showImg: 'Show pictures',
      effectTime: 'Valid period',
      addTime: 'add time',
      price2: 'price',
      type: 'Types of',
      couponIcon: 'Card roll display icon',
      itemEffect: 'Special effects',
      effectTimeDay: 'Effective time (days)',
      delCoupon: 'Confirm to delete the coupon?',
    },
    // 设置
    setting: {
      tab1: 'Guessing dice Settings',
      tab2: 'userNo lock',
      tab3: 'Lowest version number',
      tab4: 'The official account',
      tab5: 'Gold task',
      tab6: 'Active Blacklist Setting',
      tab7: 'ID mall',
      tab8: 'Ios controls the version number',
      tab9: 'Game blacklist',
      tab10: 'System Field Settings',
      tab11: 'Version Number Setting',
      tab12: 'Official Account Settings',
      tab13: 'ID lock',
      tab14: 'Lucky box',

      tab1txt1: 'Guessing fist, sieve entrance:',
      tab1txt2: 'Is showing off',
      tab1txt3: 'Has been blocked',
      tab1txt4: 'Are you sure to show guessing, sieve entry?',
      tab1txt5: 'Are you sure to screen the entrance of guessing fist and sieve?',
      tab2txt1: 'Change a note',
      tab3txt1: 'The version number',
      tab3txt2: 'The current version',
      tab4txt1: 'The official room',
      tab4txt2: 'The official user',
      tab4txt3: 'New users',
      tab4txt4: 'In English, separate',

      tab5txt1: 'The name of the task',
      tab5txt2: 'Task type',
      tab5txt3: 'Reward of gold',
      tab5txt4: 'Daily tasks',
      tab5txt5: 'Growth task',
      tab5txt6: 'Task details',
      tab5txt7: 'Sign-in page',

      tab6txt1: 'name',
      tab6txt2: 'digits',
      tab6txt3: 'ID type',
      tab6txt4: 'Adding ID Specifications',
      tab6txt5: 'ID feedback list',
      tab6txt6: 'ID number',
      tab6txt7: 'ID specification',
      tab6txt8: 'userNo type',
      tab6txt9: 'Gold prices',
      tab6txt10: 'ID numbers on sale',
      tab6txt11: 'Manage the ID list',
      tab6txt12: 'Two digits',
      tab6txt13: 'Three digits',
      tab6txt14: 'Four digits',
      tab6txt15: 'Five digits',
      tab6txt16: 'Six digits',
      tab6txt17: 'Seven digits',
      tab6txt18: 'eight digits',
      tab6txt19: 'With no.',
      tab6txt20: 'pairs',
      tab6txt21: 'Even no.',
      tab6txt22: 'Set up the',

      tab7txt1: 'Submit time',
      tab7txt2: 'Feedback ID',
      tab7txt3: 'reply',
      tab7txt4: 'ignore',
      tab7txt5: 'Have to reply',
      tab7txt6: 'Has been ignored',
      tab7txt7: 'Manage the ID list',
      tab7txt8: 'You can sell',
      tab7txt9: 'Not for sale',
      tab7txt10: 'lock',
      tab7txt11: 'Has been locked',
    },
    // 家族信息查询
    familyInformation: {

      keyStr: 'Please enter the family ID',
      query: 'query',
      newFamily: 'Create a family',
      editor: 'editor',
      viewFamily: 'View family members',
      dissolutionFamily: 'The dissolution of the family',
      keyword: 'Family ID',
      familyId: 'Family ID',
      familyName: 'Family name',
      familyOwner: 'The heads of the',
      familyOwnerid: 'The heads of the id',
      familyPortrait: 'Family portrait',
      membership: 'membership',
      familyLevel: 'The family level',
      wealthLeave: 'Level of wealth',
      charmLeave: 'Glamour rating',
      incomeBate: 'Divided into the proportion',
      incomeToday: 'Today\'s Family income (YUAN)/ Flow (yuan)',
      incomeMonth: 'Family income (YUAN)/ Water (yuan) this month',
      incomeLastMonth: 'Last month family income (yuan)/ Water (yuan)',
      incomeCount: 'Total family income (yuan)/ Flowing water (yuan)',

      confirmOne: 'Confirm the dissolution of the family?',

      familyList: 'Family list',
      memberId: 'Please enter the member id',
      outFamily: 'Kicked out of the family',
      NmemberId: 'Member id',
      F_memberId: 'Family member name ID',
      memberNickname: 'Members of the nickname',
      gender: 'gender',
      memberHead: 'Members of the head',
      cToday: 'Contribution today (Diamond)',
      cMonth: 'Contribution of the Month (Diamond)',
      toast1: 'Confirm that will change the members of the proposed family?',

      fmilyInformation: 'Family information',
      familyDeclaration: 'The declaration of the family',
      starFamily: 'Is it the Star Family',
      proportion: 'Divided into the proportion',
      between: 'Percentage: Please enter a value between 0 and 100',
      notNull: '*Have to empty',
      memberIds: 'Five founding member ids',
      noMember: 'Members of the lack of',
      familyNameNotNull: 'Clan name cannot be empty',
      createdIdNotNull: 'Patriarch id cannot be empty',
      avatarNotNull: 'Family profile picture cannot be empty',
      reportNotNull: 'Family declaration cannot be empty',
      rateNotNullOrNum: 'The share ratio cannot be empty or should be a number',
      dissolutFamily: 'Family Dissolution Application',

    },
    // 家族解散申请列表
    familyDissolution: {
      familySearch: 'Guild Query',
      dissolution: 'Guild Dismiss Application',
      familyId: 'Guild ID',
      familyName: 'Guild Name',
      familyImg: 'Guild Avatar',
      ownerId: 'Guild Owner ID',
      nickname: 'Guild Owner Name',
      level: 'Guild Level',
      starLevel: 'Guild Grade',
      number: 'Member number',
      addTime: 'Application Time',
      dissolutioned: 'Dismissed',
      ignore: 'Ignore',
      ignored: 'Ignored',
      dissolutionFam: 'Dismiss the guild',
      checkDissolut: 'Confirm to dismiss',
      checkIgnore: 'Confirm to ignore',
      text: 'To audit',

    },
    superTube: {
      liangNick: 'Pretty ID',
      cancelAdmin: 'Cancel super administrator',
      liangKey: 'ID',
      liangId: 'Pretty ID',
      avatar: 'Avatar',
      nickname: 'nickname',
      country: 'country',
      lastLogin: 'Last login',
      checkCancelAdmin: 'Are you sure to cancel the super administrator?',
    },
    national: {
      liangNick: 'Pretty ID',
      cancelNation: 'Cancel country administrator',
      liangKey: 'Pretty ID',
      liangId: 'Pretty ID',
      avatar: 'Avatar',
      nickname: 'nickname',
      country: 'country',
      lastLogin: 'Last login',
      checkCancelNation: 'Are you sure to cancel the country administrator?',
    },

    // 敏感词管理
    sensitiveWords: {
      keyword: 'keyWord',
      newSensitiveWords: 'New sensitive words',
      record: 'record',
      drecord: 'Don\'t record',
      editSensitive: 'Sensitive word editing',
      sensitiveWords: 'Sensitive words',
      shouldRecord: 'Should record',
      addTime: 'Add the time',
      UpdateTime: 'Update time',
      toast1: 'Are you sure to delete it?',
    },
    // 丢单管理
    lostOrder: {
      keyWord: 'Lost tracking number/user ID',
      startTime: 'The start time',
      endTime: 'The end of time',
      dataType: 'The data type',
      topUp: 'top-up',
      gold: 'Gold COINS',
      date: 'The date of',
      userID: 'The user ID',
      nickname: 'The user nickname',
      amountReceived: 'Amount received (yuan)',
      agentRecharge: 'Agent recharge (USD)',
    },
    account: {
      addAccount: 'Add administrator account',
      edit: 'Edit',
      ban: 'Disable',
      unBan: 'Unban',
      addTo: 'On list',
      unAddTo: 'Off the shelf',
      accountId: 'Administrator ID',
      username: 'Username',
      realname: 'Real name',
      role: 'Roles',
      text: 'Operating area',

      lastLoginTime: 'Last Login Time',
      fiveM: '5 minutes',
      oneH: '1 hour',
      twoH: '2 hours',
      twelveH: '12 hours',
      sureDelete: 'Sure to delete?',
      sureBanAccount: 'Sure to ban this account',
      sureUnBanAccount: 'Sure to unban this account',
    },
    //
    windDetail: {
      setAccount: 'Account Settings',
      username: 'Username',
      newPassword: 'New Password',
      checkPassword: 'Confirm Password',
      realname: 'Real name',
      role: 'Roles',
    },
    //
    authorityManagement: {
      addRole: 'Add role',
      editRole: 'Edit role',
      editAuthority: 'Edit permissions',
      roleInfo: 'Role information',
      sort: 'Serial number',
      roleName: 'Role',
      authority: 'Permission editing',
      role: 'Roles',
      text1: 'Module permission Management',
      text2: 'The module',
      text3: 'Operation name',
      text4: 'Whether to enable',
      text5: 'Module permission Setting',
      tabText2: 'Big R recharge data tracking',
      text6: 'Item distribution restriction list',
      text7: 'Authorization list',

    },
    //
    menuagement: {
      add: 'Add',
      editAuthority: 'Modify permissions',
      menuName: 'Menu',
      name: 'Name',
      back: 'Return',
      authorityName: 'Function',
      sureDeleteMenu: 'Sure to delete this menu',
      sureDeleteAuthority: 'Confirm to delete the permission',
    },
    countryArr: {
      language1: 'English',
      language2: 'Arabic area',
      language3: 'Indonesian region',
      language4: 'Turkish region',
      language5: 'Indian',
      language6: 'Vietnamese',
      language7: 'Thai',
      language8: 'Spanish',
      language9: 'Portuguese',

    },
    stateManagement: {
      addCountry: 'New country',
      tableText1: 'Country Name',
      tableText2: 'Country icon',
      updateCountry: 'Edit country',
      nameOrImgNotNull: 'Country name and country icon cannot be empty',
    },
    hostManagement: {
      userId: 'User ID',
      searchText1: 'Please enter the user ID',
      searchText2: 'Please enter an accurate user ID',
      searchText3: 'Set as anchor',
      searchText4: 'User Management',
      searchText5: 'Group management',
      searchText6: 'Select group',
      searchText7: 'Diamond zero clearance list',
      searchText8: 'Association limited',
      tableText1: 'Avatar',
      tableText2: 'Nickname',
      tableText3: 'Gender',
      tableText4: 'Wealth/Charm/Active',
      tableText5: 'Diamond balance',
      tableText6: 'Historical deduction of diamonds',
      tableText7: 'Gold coin balance',
      tableText8: 'Room Id',
      tableText9: 'Room flow this week',
      tableText10: 'The room flowed last week',
      tableText11: 'The room flowed last week',
      tableText12: 'The room flowed last week',
      tableText13: 'Total water flow in the room',
      tableText14: 'Registration time',
      tableText15: 'Last login time',
      tableText16: 'Number of days online this week',
      tableText17: 'Number of days online this month',
      tableText18: 'In the guild',
      operatText1: 'Modify group',
      operatText2: 'Cancel the anchor',
      operatText3: 'Deduct diamonds',
      operatText4: 'Unlock',
      operatText5: 'Enter the required deduction',
      operatText6: 'Are you sure you want to cancel the anchor?',
      operatText7: 'Are you sure to lock the diamond?',
      operatText8: 'Add user group',
      operatText9: 'Modify user group',
      operatText10: 'Lock diamond',
      operatText11: 'OK to unlock the diamond',
      table2Text1: 'group name',
      table2Text2: 'Remarks',
      warnText1: 'Please enter user id',
      warnText2: 'Make sure to set as the host',
      warnText3: 'Confirm to cancel the anchor',
      table3Text1: 'time',
      table3Text2: 'Deduction',
      title3Text1: 'Diamond deduction record',
      title4Text1: 'Top 20 room contribution list',
      title4Text2: 'This week',
      title4Text3: 'Last week',
      title4Text4: 'two weeks ago',
      title4Text5: 'Last last week',
      title4Text6: 'history',
      table4Text1: 'nickname',
      table4Text2: 'Pretty id',
      table4Text3: 'Contribution',
      warnText4: 'Please enter a group name',
      warnText5: 'Confirm to delete the group information',
      warnText6: 'The number of diamonds deducted cannot be empty',
      warnText7: 'Determine to modify the group',
      table5Text1: 'Clear the diamond balance of previous users',
      table5Text2: 'roomNO.',
      table5Text3: 'Add restrictions',
      table5Text4: 'Is it the president',
      table5Text5: 'Reset the diamond',
      table5Text6: 'Confirm that the selected user diamond is cleared?',
      table5Text7: 'Set up,',
      table5Text8: 'Confirm modification director?',
    },
    languageText: {
      areaText1: 'English area',
      areaText2: 'Arabic area',
      areaText3: 'Indonesian-speaking area',
      areaText4: 'Turkish speaking region',
      areaText5: 'Hindi-speaking area',
      areaText6: 'Vietnamese area',
      areaText7: 'Thai-speaking area',
      areaText8: 'Spanish area',
      areaText9: 'Portuguese Quarter',
    },
    agentManagement: {
      tabText1: 'Agent Statistics',
      tabText2: 'Recharge Record',
      tabText3: 'Agent Information',
      tabText4: 'Monthly Sales Statistics',
      search1Text1: 'User ID',
      table1Text1: 'Agent ID',
      table1Text2: 'Avatar',
      table1Text3: 'Nickname',
      table1Text4: 'Gold coin balance',
      table1Text5: 'Total sales this month (USD)',
      table1Text6: 'Last month\'s total sales (USD)',
      table1Text7: 'Cumulative total sales (USD)',
      table1Text8: 'Total recharge this month (USD)',
      table1Text9: 'Total recharge last month (USD)',
      table1Text10: 'Cumulative total recharge (USD)',
      table1Text11: 'Last Payment Time',
      table1Text12: 'Recent charging time',
      table1Text13: '24-hour sales (USD)',
      table1Text14: 'Top-up gold COINS',
      table1Text15: 'Recharge the whitelist',
      table1Text16: 'To protect the',
      table1Text17: 'Has the failure',
      table1Text18: 'Start time of protection',
      table1Text19: 'Protection end time',

      opera1Text1: 'Ta recharged person',
      opera1Text2: 'Agent recharge',
      opera1Text3: 'Regional Agent',
      opera1Text4: 'Select country',
      opera1Text5: 'Selected country:{country}',
      search2Text1: 'Agent recharge',
      table2Text1: 'release time',
      table2Text2: 'Agent id',
      table2Text3: 'Nickname',
      table2Text4: 'Recharge amount',
      table2Text5: 'Recharge gold coins',
      table2Text6: 'Payment method',
      table2Text7: 'Payment Remarks',
      table2Text8: 'Issuer',
      table2Text9: 'Actual receipt',
      table2Text10: 'Receipt Confirmer',
      table2Text11: 'Confirm time',
      opera2Text1: 'Confirmed paid',
      search3Text1: 'Add proxy information',
      search3Text2: 'Edit agent information',
      table3Text1: 'Agent id',
      table3Text2: 'Agent area',
      table3Text3: 'Common payment methods',
      table3Text4: 'Payment account name',
      table3Text5: 'Resident Country',
      table3Text6: 'Phone',
      table3Text7: 'WeChat ID',
      table3Text8: 'whatsapp',
      table3Text9: 'Mailbox',
      table3Text10: 'Starchat id',
      table3Text11: 'Main docking person',
      table4Text1: 'Year Month',
      table4Text2: 'Total Receipt of Tuyin District',
      table4Text3: 'Monthly month-on-month ratio of repayment in Tuyin District',
      table4Text4: 'Total Sales in Tuyin District',
      table4Text5: 'Number of recharged users in Tuyin District',
      table4Text6: 'Number of top-ups in Tuyin District',
      table4Text7: 'The total amount of money received in the Arabic language area',
      table4Text8: 'Monthly month-on-month payment in Arabic area',
      table4Text9: 'Total sales in Arabic area',
      table4Text10: 'Number of top-up users in Arabic area',
      table4Text11: 'Number of top-ups in Arabic area',

      table5Text1: 'User ID',
      table5Text2: 'Registration time',
      table5Text3: 'Avatar',
      table5Text4: 'nickname',
      table5Text5: 'Top-up amount (USD)',
      table5Text6: 'Recharge time',
      table5Text7: 'Gold coin balance',
      table5Text8: 'Diamond balance',
      search5Text1: 'Export report',

      table6Text1: 'Top up gold coins',
      table6Text2: 'Top-up amount (USD)',
      table6Text3: 'Recharge time',

      warnText1: 'Please select a country',
      warnText2: 'Confirm cancellation of regional agent',
      warnText3: 'The user has set the proxy country',
      warnText4: 'Fill in the form cannot be empty',
      warnText5: 'Agent Id cannot be empty',

      payType1: 'HSBC transfer',
      payType2: 'Citi Transfer',
      payType3: 'tap recharge',
      payType4: 'paypal',
      payType5: 'Alipay',
      payType6: 'Western Union Pay',
      payType7: 'Surrogate fee',
      payType8: 'Eggplant pay',
      payType9: 'Payoneer',

      proxyForm1: 'Agent Id',
      proxyForm2: 'Recharge amount',
      proxyForm3: 'Number of gold coins',
      proxyForm4: 'payment method',
      proxyForm5: 'Payment note',
      proxyForm6: 'Pay the password',
      proxyForm7: 'Bill serial number',
      proxyForm8: 'Cancel the reason',
      proxyForm9: 'Add area',
    },
    roomCrystal: {
      tabText1: 'Crystal Gift List',
      tabText2: 'Crystal level display',
      tabText3: 'Crystal Room',
      table1Text1: 'Crystal Level',
      table1Text2: 'Item Name',
      table1Text3: 'Crystal display icon',
      table1Text4: 'Gold coin amount',
      table1Text5: 'Quantity',
      table1Text6: 'Display sort',
      table1Text7: 'Probability of winning',
      table1Text8: 'Valid time',
      table1Text9: 'Valid duration (days)',
      table1Text10: 'Created time',
      opera1Text1: 'Add gold coin',
      opera1Text2: 'New gift',
      opera1Text3: 'New card coupon',
      opera1Text4: 'New item',
    },

    // 活动管理
    ActivityManagement: {
      page1: 'Weekly Star activity gift setting',
      page2: 'Weekly Star Event Gifts',
      page3: 'Weekly Star award allocation',
      page1_1: 'The current activity',
      page1_2: 'Historical events',
      page2_1: 'The activity time',
      page2_2: 'Weekly Star gift',
      page2_3: 'Gift-giving list',
      page2_4: 'Room Gift List',
      page2_5: 'List of day',
      page2_6: 'List of week',
      page2_7: 'Room / gift list',
      page2_8: 'Daily / weekly list',

      page3_1: 'new reward',
      page3_2: 'Reward name',
      page3_3: 'Days/Quantity',
      page3_4: 'rank',
      page3_5: 'reward type',
      page3_6: 'gift type',


      rank1: 'First place',
      rank2: 'second',
      rank3: 'Third',

      type1: 'Day to reward',
      type2: 'Week of reward',
      type3: 'Room reward',

      gift1: 'Small gifts',
      gift2: 'medium present',
      gift3: 'Big gift',

      gtype1: 'The car/headgear',
      gtype2: 'Total cost of the gift',
      toast: 'Please select Monday',

      day1: 'Monday',
      day2: 'Tuesday',
      day3: 'Wednesday',
      day4: 'Thursday',
      day5: 'Friday',
      day6: 'Saturday',
      day7: 'Sunday',

      page4_1: 'For the time',
      page4_2: 'Preliminary sorting',
      page4_3: 'The room',
      page4_4: 'The contestants',
      page4_5: 'Player vote',
      page4_6: 'Shelf time',
      page4_7: 'Under the frame of time',
      page4_8: 'Polling begins each day',
      page4_9: 'Polls close each day',
      page4_10: 'operation',

      page4_11: 'The preliminary stage',
      page4_12: 'The final stage',
      page4_13: 'Activity information',

      page4_14: 'Each day the game starts inside the room',
      page4_15: 'Finish time of each day inside the room',
      page4_16: 'Enter the user ID, separated by commas in the English state',
      page4_17: 'The other area',
      page4_18: 'votes',
      page4_19: 'Video link',
      page4_20: 'The picture',
      page4_21: 'note',
      page4_22: 'The other area',


      activityPage3tab1: 'Prize pool set',
      activityPage3tab2: 'Draw volume',

      activityPage3tab1txt1: 'The prize ID',
      activityPage3tab1txt2: 'Name of the prize',
      activityPage3tab1txt3: 'The prize type',
      activityPage3tab1txt4: 'The value of',
      activityPage3tab1txt5: 'Expiry date (days)',
      activityPage3tab1txt6: 'Valid Duration (days)',
      activityPage3tab1txt7: 'The current number of',
      activityPage3tab1txt8: 'Daily critical quantity',
      activityPage3tab1txt9: 'The prize probability',
      activityPage3tab1txt10: 'On/off the shelves',
      activityPage3tab1txt11: 'Whether to push',
      activityPage3tab1txt12: 'Whether the public screen',
      activityPage3tab1txt13: 'New prize pool',
      activityPage3tab1txt14: 'Scroll up or not',

      activityPage3tab1txt15: 'Unit Price (gold coins)',

      volume1: 'The user ID',
      volume2: 'The user nickname',
      volume3: 'Creation time',
      volume4: 'Update time',
      volume5: 'The number of',

      activityPage4tab1: 'Prize pool set',
      activityPage4tab2: 'Statistical query',
      activityPage4tab3: 'Change Settings',
      activityPage7tab1: 'I love the wall',



      activityPage5txt1: 'area',
      activityPage5txt2: 'Top-up level',
      activityPage5txt3: 'The props',
      activityPage5txt4: 'Item type',
      activityPage5txt5: 'The value of',
      activityPage5txt6: 'Quantity/days',
      activityPage5txt7: 'operation',
      activityPage5txt8: 'New prepaid phone',
      activityPage5txt9: 'Delete selected items',


      activityPage6txt1: 'New bonus items',
      activityPage6txt2: 'The activity type',

      activityPage6txt3: 'Week of cp',
      activityPage6txt4: 'Zhou Xing reward',
      activityPage6txt5: 'Month crown charm',
      activityPage6txt6: 'In champions league contribution',
      activityPage6txt7: 'CP certification',
      activityPage6txt8: 'ranking',
      activityPage6txt9: 'Reward name',
      activityPage6txt10: 'gender',
      activityPage6txt11: 'all',
      activityPage6txt12: 'male',
      activityPage6txt13: 'female',

      activityPage7txt1: 'CPID1',
      activityPage7txt2: 'countries',
      activityPage7txt3: 'CPID2',
      activityPage7txt4: 'Current number of hearts',
      activityPage7txt5: 'Current number of blessings',
      activityPage7txt6: 'Shelf time',
      activityPage7txt7: 'Under the frame of time',

      activityPage7txt8: 'I love ID',
      activityPage7txt9: 'nickname',
      activityPage7txt10: 'Do be ID',
      activityPage7txt11: 'I love it',
      activityPage7txt12: 'Release time',
      activityPage7txt13: 'Thumb up for',
      activityPage7txt14: 'The message content',



      text1: 'Item id',
      text2: 'Prop the name',
      text3: 'The receiver id',
      text4: 'Item Type ID',
      text5: 'Item type',
      text6: 'Distribution of reason',
      text7: 'Period of validity',
      text8: 'Conversion period',
      text9: 'The number of',
      text10: 'Conversion period',

      page6_1: 'The activity type',
      page6_2: 'Week start time',
      page6_3: 'area',
      page6_4: 'Charm list',
      page6_5: 'Contribution to the list',
      page6_6: 'The room list',


      page6_7: 'The Turkey',
      page6_8: 'Turkey',
      page6_9: 'area',
      page6_10: 'Top-up level',
      page6_11: 'Please complete the information',


      page7_1: 'The name of the event',
      page7_2: 'Family ID(left)',
      page7_3: 'Family ID(right)',
      page7_4: 'Family integral (left)',
      page7_5: 'Family integral (right)',
      page7_6: 'Room ID(left)',
      page7_7: 'Room ID(right)',
      page7_8: 'rounds',
      page7_9: 'League list',
      page7_10: 'Set the time',
      page7_11: 'second',
      page7_12: 'The quarter-finals',
      page7_13: '1/2 final',
      page7_14: 'The final',


      page8_1: 'Participating countries',
      page8_2: 'Opening time of polling',
      page8_3: 'Closing time of polling',
      page8_4: 'The final',
      page8_5: 'The final',
      page8_6: 'The final',

      page9_1: 'Old Week of star',
      page9_2: 'Week of CP',
      page9_3: 'On the champions league',
      page9_4: 'The star of the birthday',
      page9_5: 'New Week of star',
      page9_6: 'The activity type',
      page9_7: 'Wall of Honor',
      page9_8: 'Jump in the url',
      page9_9: 'Add the time',
      page9_10: 'Start time',
      page9_11: 'The end time of the presentation',
      page9_12: 'Owning region',
      page9_13: 'Whether to automatically obtain the profile picture',
      page9_14: 'New Week of star',
      page9_15: 'Wall of Honor',
      page9_16: 'Wall of Honor information',


      page10_1: 'Room PK',
      page10_2: 'Personal PK',
      page10_3: 'Family PK',
      page10_4: 'PK category',
      page10_5: 'Pk_id (left)',
      page10_6: 'Integral (left)',
      page10_7: 'Pk_id (right).',
      page10_8: 'Integral (right)',
      page10_9: 'Pk start time',

      page10_10: 'Pk end time',
      page10_11: 'Pk category',
      page10_12: 'Conventional pk',
      page10_13: 'Season pk',
      page10_14: 'PK information',


      page11_1: 'On the right',
      page11_2: 'On the left',
      page11_3: 'location',

      page11_4: '128 to 32',
      page11_5: '32 into 16 stages',
      page11_6: '16 into 8 stages',
      page11_7: '8 steps and 4 stages',
      page11_8: '4 stages and 2 stages',
      page11_9: 'The final stage',
      page11_10: 'winner',
      page11_11: 'Final closing time of voting',
      page11_12: 'Vote results',

      page11_13: 'Candidate ID',
      page11_14: 'Candidate nickname',
      page11_15: 'votes',
      page11_16: 'Modify the votes',
      page11_17: 'Confirm the change of vote?',
      page11_18: 'List of contestants',

      page12_1: 'Entry room',
      page12_2: 'Participating countries',

      activityPage4tab1txt1: 'Number of pieces',
      activityPage4tab1txt2: 'The current number of',
      activityPage4tab1txt3: 'Daily critical quantity',
      activityPage4tab1txt4: 'The prize probability',
      activityPage4tab1txt5: 'Duration of use (days)',
      activityPage4tab1txt6: 'Expiry date (days)',
      activityPage4tab1txt7: 'Daily critical quantity',
      activityPage4tab1txt8: 'shuffling',
      activityPage4tab1txt9: 'Display icon',
      activityPage4tab1txt10: 'Edit the prize',
      page13_1: 'The wedding',
      page13_2: 'Birthday party',
      page13_3: 'The host',
      page13_4: 'Party ID',
      page13_5: 'Party type',
      page13_6: 'Host id',
      page13_7: 'Host nickname',
      page13_8: 'Applicant id',
      page13_9: 'User 1 Jane id',
      page13_10: 'User 2 Jane id',
      page13_11: 'Through the note',
      page13_12: 'Declined to comment',







    },
    familyStar: {
      tab1: 'Custom title & list data',
      tab2: 'Gift set',
      tab1text1: 'list',
      tab1text2: 'List of the family',
      tab1text3: 'Family member list',
      tab1text4: 'List the type',
      tab1text5: 'The title of the type',
      tab1text6: 'Custom title',
      tab1text7: 'Confirm the modification?',
      tab1text8: 'Please enter a new title',
      tab2text1: 'Present 1',
      tab2text2: 'Present 2',
      tab2text3: 'Present 3',

    },
    jackpotActivities: {
      tab1: "play law message",
      tab2: "team message",
      searchText1: "Activity serial number",
      newActivityNum: "Add activity serial number",
      language: "language",
    },
    theVoice:{
      tab1:'Tutor list',
      tab2:'List of contestants',
      tab3:'Activity configuration',

      title1:'newly added',
      title2:'edit',

      btnText1:'newly added',

      titleText1:'Activity ID',
      titleText2:'region',
      titleText3:'country',
      titleText4:'leg',
      titleText5:'Activity room',
      titleText6:'Voting start time',
      titleText7:'Voting end time',

      titleText8:'Player nickname',
      titleText9:'Contestant declaration',
      titleText10:'Free tickets',
      titleText11:'Number of gift tickets',
      titleText12:'Number of gold coins',
      titleText13:'Player video',
      titleText14:'title',
      titleText15:'votes',

      formText1:'leg',
      formText2:'Voting start time',
      formText3:'Voting end time',
      formText4:'Start time of the game',
      formText5:'End time of the game',
      formText6:'Campaign status',
      formText7:'Number of votes',
      formText8:'Team',
      team_name:'Team Name',

      user_no:'Player ID',
      tutorId:'Tutor ID',
      showVideo:'View video',
    },

    championships:{
      tab1:'Race schedule',
      tab2:'Template',
      isOff:'Off the shelf',
      activityId:'Activity ID',
      newActivity:'New competition',
      newTemplate:'New template',

      nickname:'nickname',

      tableText1:'Activity main title',
      tableText2:'Activity subtitle',
      tableText3:'activity type',
      tableText4:'Registration fee',
      tableText5:'Registration deadline',
      tableText6:'Registration limit',
      tableText7:'Number of promotion',
      tableText8:'start time',
      tableText9:'End time',
      tableText10:'Page URL',
      tableText11:'Created by',
      tableText12:'region',
      tableText13:'country',

      tableText14:'Serial number',
      tableText15:'User ID',
      tableText17:'Applicant',
      tableText18:'Registration time',

      tableText19:'ranking',
      tableText20:'Gold Award',
      tableText21:'Winner ID',
      tableText23:'Editor',
      tableText24:'Edit time',

      tableText25:'Race times',
      tableText26:'Competition room',
      tableText27:'Assigned quantity',

      tableText28:'Group number',

      title1:'New competition',
      title2:'Edit competition',
      title3:'Entry list management',
      title4:'Group management',
      title5:'Reward management',
      title6:'New template',
      title7:'Edit template',
      title8:'Add group member',

      actTypeOpt1:'Ludo competition',

      formText1:'Event type',
      formText2:'Activity theme',
      formText2_1:'Activity title',
      formText3:'Event time',
      formText4:'Event header',
      formText5:'Top1 reward chart',
      formText5_1:'Top2 reward chart',
      formText5_2:'Top3 reward chart',
      formText6:'Activity administrator',
      formText7:'Registration requirements',
      formText8:'Any level greater than',
      formText9:'Room ID',
      formText10:'Multiple room ID numbers can be filled in, separated by commas',
      formText11:'Multiple user ID numbers can be filled in, separated by commas',
      formText12:'Top n',

      formText13:'Group size',
      formText14:'direction',

      signUpList:'Application form',
      raceSchedule:'Race schedule',
      reward:'reward',
      editGroup:'Edit group',

      btnText1:'Agent registration',
      btnText2:'Add rewards',
      btnText3:'Batch Award',

      btnText4:'Delete all groups',
      btnText5:'Automatic randomization',
      btnText6:'Add group',

      btnText7:'Set winners',
      btnText8:'Add member',
      btnText9:'Group view',
      btnText10:'One click export',

      warningText:'Click OK to clear all current grouping information and re assign groups. Are you sure you want to randomly group?',

      errorText:'Please select an activity theme',
      errorText2:'Upload picture exceeds the limit size',
      goldError:'Please enter the reward amount',
      topError:'Please select a parent',

      mianImgText:'size',

      isPrize:'Issued',
      chooseRound:'Please select the round',

    },

    // 房间专栏
    roomColumn: {
      bannerImg: 'Banner figure',

      tabText1: 'Room banner',
      tabText2: 'banner application',
      tabText3: 'Found page banner',

      table1Text1: 'sort',
      table1Text2: 'English',
      table1Text3: 'Arabic',
      table1Text4: 'Spanish',
      table1Text5: 'Turkish',
      table1Text6: 'Hindi',
      table1Text7: 'Vietnamese',
      table1Text8: 'Thai',
      table1Text9: 'Indonesia',
      table1Text10: 'Portuguese',
      table1Text11: 'Removal time',
      table1Text12: 'Cover image',
      table1Text13: 'big picture',
      table1Text14: 'Room',
      table1Text15: 'Already on shelves',
      table1Text16: 'Not listed',
      table1Text17: 'Region',
      table1Text18: 'Remove',
      table1Text19: 'On shelf',
      table1Text20: 'Shelf time',
      table1Text21: 'Added time',
      table1Text22: 'Time off',
      table1Text23: 'Note: Entering 1 means that the title is not displayed in this area.',
      table1Text24: 'Column Name (English)',
      table1Text25: 'Column name (Arabic)',
      table1Text26: 'Column name (Spanish)',
      table1Text27: 'Column name (Turkish)',
      table1Text28: 'Column name (Hindi)',
      table1Text29: 'Column name (Vietnamese)',
      table1Text30: 'Column name (Thai)',
      table1Text31: 'Column name (Indonesian)',
      table1Text32: 'Column name (Portuguese)',
      table1Text33: 'External image',
      table1Text34: 'Inner image',
      table1Text35: 'Jump Type',
      table1Text36: 'H5',
      table1Text37: 'Post',
      table1Text38: 'Topic',
      table1Text39: 'Internal picture room ID',
      table1Text40: 'URL',
      table1Text41: 'topic id/post id',
      table1Text42: 'Sort',
      table1Text43: 'Shelf time',
      table1Text44: 'Removal time',
      table1Text45: 'every day on shelf time',
      table1Text46: 'Daily removal time',
      table1Text47: 'Add and copy related functions',
      table1Text48: 'Please choose the type',
      table1Text49: 'Internal image binding ID',
      table1Text50: 'H5 link',
      table1Text51: 'Please enter the daily shelf time',
      table1Text52: 'Please enter the time of day off the shelf',
      table1Text53: 'Sort input box cannot be empty',
      table1Text54: 'External image cannot be empty',
      table1Text55: 'room',
      table1Text56: 'Event Details',
      table2Text57: 'Nationality',
      table2Text58: 'Room ID',
      table2Text59: 'Homeowner ID',
      table2Text59_1: 'Proposer ID',
      table2Text60: 'Activity Name',
      table2Text61: 'Activity start time',
      table2Text62: 'Activity duration',
      table2Text63: 'Activity Description',
      table2Text64: 'Social Media Account',
      table2Text65: 'Social media screenshot',
      table2Text66: 'Banner screenshot',
      table2Text67: 'banner application area',
      table2Text68: 'hour',
      table1Text69: 'Confirm to perform the listing operation',
      table1Text70: 'Confirm execution of delisting operation',
      table1Text71: 'Loading and unloading operations',
      table1Text72: 'Added time',
      table1Text73: 'Off-shelf time',
      table1Text74: 'The shelf time or the shelf time cannot be empty',
      table1Text75: 'Confirm delete operation',
      table2Text76: 'Confirm to execute the pass operation',
      table2Text77: 'Confirm rejection operation',
      table2Text78: 'Reason for rejection',

      table1Text78: 'URL',
      table1Text79: 'Post id',
      table1Text80: 'Topic id',
      table1Text81: 'The room id',
      table1Text82: 'Activity id',
      table1Text83: 'Please fill in the reason for refusal',

      table1Text84: 'Banner URL/ rule URL',
      table1Text85: 'Banner Room COLOR ID/Topic ID/Post ID',
      table1Text86: 'Whether to allow users to apply',
      table1Text87: 'Shelf time per day',
      table1Text88: 'Daily takedown time',
      table1Text89: 'Column room list',
      table1Text90: 'Certification level',
      table1Text91: 'Support activities this month',
      table1Text92: 'Room activities',
      table1Text93: 'Column activity',
      table1Text94: 'Picture size does not match',
      table1Text95: 'Picture size does not match',
      table1Text96: 'Column Support Activities',
      table1Text97: 'To add a banner',
      table1Text98: 'Add a column',
      table1Text99: 'Edit the banner',
      table1Text100: 'Edit the column',

      table1Text101: "Coming soon",
      table1Text102: "Applicant",
      table1Text103: "Please enter applicant",
      table1Text104: "Up rooms",
      table1Text105: "Down rooms",

      table2Text1: 'A blind date ',
      table2Text2: 'cricket',
      table2Text3: 'The film show',
      table2Text4: 'Talk show',
      table2Text5: 'music',
      table2Text6: 'Lucky dog',
      table2Text7: 'header',
      table2Text8: 'The wedding',
      table2Text9: 'birthday',
      table2Text10: 'Bachelor party',
      table2Text11: 'Banner Column type',
      table2Text12: 'The room list',

      table2Text13: 'Inner graph jump type',
      table2Text14: 'Inner map URL/ rule URL',
      table2Text15: 'Inside picture room id/ topic ID/post ID',
      table2Text16: 'bingo',
      table2Text17: 'Talent show',
      table2Text18: 'poetry',
      table2Text19: 'guessing',
      table2Text20: 'Room column',

    },
    violationUser: {
      table1Text1: 'Pretty Number',
      table1Text2: 'Avatar',
      table1Text3: 'Nickname',
      table1Text4: 'Registration time',
      table1Text5: 'violating picture',
      table1Text6: 'Login ip',
      table1Text7: 'List of offending users',
      table1Text8: 'Operation Violation User',
      table1Text9: 'Ignore',
      table1Text10: 'Ban',
      table1Text11: 'Confirm ignore operation',
      table1Text12: 'Confirm to perform the ban operation',
      table1Text13: 'Banned',
      table1Text14: 'Ignored',
    },
    systemMessage: {
      tabText1: 'System Message',
      tabText2: 'Message feedback',
      // tabText3: 'Private Message List',
      tabText3: 'send private message ',
      tabText4: 'Room public screen information',
      table1Text1: 'Release time',
      table1Text2: 'Title',
      table1Text3: 'Content',
      table1Text4: 'Picture',
      table1Text5: 'URL',
      table1Text6: 'Region',
      table1Text7: 'Delete again',
      table1Text8: 'Publish system messages',
      table1Text9: 'Released',
      table1Text10: 'will be sent',
      table1Text11: 'system information',
      table1Text12: 'URL',
      table1Text13: 'Post',
      table1Text14: 'topic',
      table1Text15: 'room',
      table1Text16: 'Event Details',
      table1Text17: 'Jump type',
      table1Text18: 'Send time',
      table1Text19: 'Target area',
      table1Text20: 'Fill in the title or content cannot be empty',
      table1Text21: 'Once again send',

      table2Text1: 'Please enter the user id to search for the user',
      table2Text2: 'User ID',
      table2Text3: 'Avatar',
      table2Text4: 'nickname',
      table2Text5: 'Screenshot',
      table2Text6: 'Feedback content',
      table2Text7: 'Feedback time',
      table2Text8: 'Confirm to delete this message feedback',

      table3Text1: 'User ID',
      table3Text2: 'Send content',
      table3Text3: 'Send time',
      table3Text4: 'Please enter the message content',
      table3Text5: 'Please enter url',
      table3Text6: 'Sender ID default 10000',
      table3Text7: 'Confirm delete operation',
      table3Text8: 'Send private chat messages',
      table3Text9: 'The sender ID',
      table3Text10: 'The receiver ID',
      table3Text11: 'Private chat messages',
      table3Text12: 'The sender',
      table3Text13: "Please select Excel (number of IDs per copy < 5000)",




      table4Text1: 'Creation time',
      table4Text2: 'Release time',
      table4Text3: 'The message content',
      table4Text4: 'Jump type',
      table4Text5: 'Launch area',
      table4Text6: 'Operation of',

      table4Text7: 'Don\'t jump',
      table4Text8: 'H5',
      table4Text9: 'Top-up page',
      table4Text10: 'Specify the room',
      table4Text11: 'User profile page',
      table4Text12: 'Mall page',
      table4Text13: 'Noble Purchase page',
      table4Text14: 'Jump topic',
      table4Text15: 'Jump post',

      table4Text16: 'Message content (English)',
      table4Text17: 'News Content (Turkey)',
      table4Text18: 'News Content (Arabic)',
      table4Text19: 'News Content (Indonesia)',
      table4Text20: 'News Content (Portuguese)',
      table4Text21: 'News Content (Hindi)',
      table4Text22: 'News Content (Spanish)',
      table4Text23: 'News Content(Thailand)',
      table4Text24: 'News Content(Vietnam)',
      table4Text25: 'Specify the room',
      table4Text26: 'Specify a user',
      table4Text27: 'Topic ID/ Post ID',
      table4Text28: 'Send time',
      table4Text29: 'Specify a user',
      table4Text30: 'Send room public screen information',
      table4Text31: 'Jump parameters',
      table4Text32: 'Cancel sending',
      table4Text33: 'Once again send',
      table4Text34: 'Today to send',
      table4Text35: 'Within 30 days',
    },
  },
  components: {
    banModal: {
      chooseTime: 'Choose a duration',
      chooseReason: 'Choose a reason:',
      banReason: "Ban reason",
      content: 'Report Content:',
      enterContent: 'You can enter the report content',
      enterUrl: 'Image or Video Link:',
      imgVideoUrl: 'Image or Video Link:',
      banUser: 'Confirm Banned Users?',
    },
    loginForm: {
      enterUserName: 'Please Enter User Name',
      enterPassword: 'Please Enter The Password',
      login: 'Log In',
      accountNotNone: 'Account Cannot Be Empty',
      passwordNotNone: 'Password Can Not Be Empty',
    },
    fullScreen: {
      exitScreen: 'Exit full screen mode',
      fullScreen: 'Full Screen',
    },
    headerBar: {
      title: 'Salam management system v1.1',
    },
    tagsNav: {
      closeAll: 'Close All',
      closeOther: 'Close Other',
    },
    user: {
      signOut: 'Sign Out',
      accountInformation: "Account information",
    },
    accountInfo: {
      username: "Name",
      role: "Role",
      operatingArea: "Operating area",
      // quotaGift: "已用/配额礼物",
      // quotaPirce: "已用/配额金币",
      // quotaProp: "已用/配额道具",
      quotaGift: "Gift quota",
      quotaGold: "Gold coin quota",
      quotaProp: "Quota props",
    },
    publicCheckPassword: {
      checkPassword: 'Enter and confirm the operation password',
      checkSuccess: 'Verify Successfully',
    },
    tableBox: {
      noneData: 'No Data',
    },
    tableSearch: {
      search: 'Query Conditions',
      searchOrOperat: 'Query conditions and operations',
    },
  },
  js: {
    request: {
      systemError: 'Server System Internal Error',
      unLogin: 'Did not logged in',
      timeOut: 'Request Timed Out',
      linkError: 'Network connection failed',
      unknownMis: 'Unknown Error',
    },
    httpJs: {
      exportNull: 'The currently exported content is empty',
    },
  },
  ...jEn,
}



// WEBPACK FOOTER //
// ./src/language/en.js